import React, { useState, useEffect, Fragment, useRef } from "react";
import { Row, Col, Form, Modal, Button, ListGroup } from "react-bootstrap";
import { deleteTwoDFile, fetchApi, uploadTwoDFile } from "../../../../utils/actions/commanActions";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import downloadFileFromS3, {
  currencyFormatter,
  numberInputOnWheelPreventChange,
  roundToTwoDigits,
} from "../../../../utils/helper";
import { ArrowDown, ArrowUp, DeleteIcon, DownloadIcon, LucidLoader, UploadIcon, WarningIcon } from "../../../../components/Icons";
import { getAllMachineDataWithPopulation } from "../../../../utils/actions/adminActions";
import { miliMeterToInchFactor } from "../../../../utils/constant";
import { CREATE_QUOTE_ACTION, useCreateQuoteContext } from "../../../../context/create.quote.context";
import "./AutomatedProcessLinesUI.css";
import Switch from "react-input-switch";
import { Select, Tooltip } from "antd";
import ThreeDViewerComponent from "../../../../components/ViewerComponent/ThreeDViewerComponent";
import SmallGlobalLoader from "../../../../components/LoaderComponent/LoaderComponent";
import SkeltonLoadingGenericComponent from "../../../../components/LoadingComponents/SkeltonLoadingGenericComponent";
import { setValues } from "../../../../context/create.quote.actions";
import FileName from "../../../../components/FileName/FileName";
import { Modal as AntModal, Space } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useInstance } from "../../../../context/instance.context";
import { getPresignedUrlForFile } from "../../../../api/helperapi/helperApi";
import AutoResizingTextarea from "../../../../components/AutoResizeTextAreaComponent/AutoResizeTextAreaComponent";


const AutomatedProcessLinesUI = (props) => {
  const { allInstanceData
    , name } = useInstance();

  // console.log("Props :", props);
  // console.log("Checking Props :", props);
  const refForSelectingGradeOnFirstLoad = useRef(true);
  const refForSelectingThreeDMaterialOnFirstLoad = useRef(true)

  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const [isCncDropDownLoading, setIsCncDropDownLoading] = useState(true);
  const { isGlobalLoading, isEditingActivatedThreeD, isEditingActivatedCnc } = props;
  const [isOpenDeleteFileModal, setIsOpenDeleteFileModal] = useState(false);


  // console.log("DropDown Loading :", isCncDropDownLoading);


  const { setSameForAllField, commanValues, handleQuoteUpdate, masterThreeDTechnologyData, setPdfModalInfo } = props;

  let { quoteId } = useParams();
  const token = localStorage.getItem("Token");
  const [threeDTechnologyData, setThreeDTechnologyData] = useState(masterThreeDTechnologyData || []);

  // console.log("masterThreeDTechnologyData :", masterThreeDTechnologyData);
  // console.log("threedTechData :", threeDTechnologyData);

  const [materialData, setMaterialData] = useState([]);
  const [surfaceFinishData, setSurfaceFinishData] = useState([]);
  const [isViewerLoading, setIsViewerLoading] = useState(false);
  const [isFirstTimeLoaded, setIsFirstTimeLoaded] = useState(true);
  const { createQuoteState, createQuoteDispatch } = useCreateQuoteContext();
  console.log('Quote state ::',createQuoteState.values);
  const [isCncMaterialChangedByDropDown, setIsCncMaterialChangedByDropDown] = useState(false);
  const [isFirstTimeLoadForCncMaterialSelect, setIsFirstTimeLoadForCncMaterial] = useState(false);
  // console.log("is cnc Material Changed :", isCncMaterialChangedByDropDown);

  const [allTechData, setAllTechData] = useState(false);
  const [allMaterialData, setAllMaterialData] = useState(false);
  const [allSurfaceFinishData, setAllSurfaceFinishData] = useState(false);
  const [isTwoDDrawringRequired, setIsTwoDDrawringRequired] = useState(true);

  //cnc
  const [selectedMachineData, setSelectedMachineData] = useState(null);
  const [materialGradeData, setMaterialGradeData] = useState(null);
  const [selectedMaterialName, setSelectedMaterialName] = useState("");

  const [selectedGradeName, setSelectedGradeName] = useState("");

  const lockRefForThreeD = useRef(false);

  const [surfaceFinish, setSurfaceFinish] = useState([]);
  const [heatTreatment, setHeatTreatMent] = useState([]);
  const [allToleranceData, setAllToleranceData] = useState([]);
  const [internalCorner, setInternalCorner] = useState([]);
  const [reviewDesign, setReviewDesign] = useState([]);
  const [partMarking, setPartMarking] = useState([]);



  const [isPostProcessThreeDChangedByDropDown, setIsPostProcessThreeDChangedByDropDown] = useState(false);

  const [isTwoDFileUploading, setIsTwoDFileUploading] = useState(false);
  const [isThreeDFileUploading, setIsThreeDFileUploading] = useState(false);
  const [isThreeDFileDownloading, setIsThreeDFileDownloading] = useState(false);


  // console.log("SingelValue", props?.singleValue)


  const keyFirst = props.selectedProcess == 1 ? 'masterPartsDataCNCId' : 'masterPartsDataThreeDId';
  const keySecond = props.selectedProcess == 1 ? 'cnc_part_show_cost' : 'threeD_part_show_cost';

  // console.log("Selected Machine :", selectedMachineData);
  const [surfaceFinishName, setSurfaceFinishName] = useState("");
  const [headTreatmentName, setHeatTreatMentName] = useState('');
  const [toleranceName, setToleranceName] = useState('');
  const [reviewMyDesignName, setReviewMyDesign] = useState('');
  const [partMarkingName, setPartMarkingName] = useState('');
  const [internalCornerName, setInternalCornerName] = useState('');

  const [threeDTechnologyName, setThreeDTechnologyName] = useState('');
  const [threeDMaterialName, setThreeDMaterialName] = useState('');
  const [threeDPostProcessName, setThreeDPostProcessName] = useState('');


  useEffect(() => {
    if (Array.isArray(masterThreeDTechnologyData)) {
      masterThreeDTechnologyData.sort((a, b) => a.name.localeCompare(b.name));
      setThreeDTechnologyData(masterThreeDTechnologyData)
    }
  }, [masterThreeDTechnologyData, props?.selectedProcess]);


  useEffect(() => {
    if (Array.isArray(surfaceFinish) && props.singleValue?.cncSurfaceFinish) {
      const name = surfaceFinish?.find(({ _id }) => _id == props.singleValue?.cncSurfaceFinish)?.cnc_surface_finish;
      setSurfaceFinishName(name);
    }

  }, [props.singleValue?.cncSurfaceFinish, surfaceFinish]);
  useEffect(() => {
    if (Array.isArray(heatTreatment) && props.singleValue?.cncHeatTreatment) {
      const name = heatTreatment?.find(({ _id }) => _id == props.singleValue?.cncHeatTreatment)?.cnc_heat_treatment;
      setHeatTreatMentName(name);
    }
  }, [props.singleValue?.cncHeatTreatment, heatTreatment]);

  useEffect(() => {
    if (Array.isArray(allToleranceData) && props.singleValue?.cncTolerance) {
      const name = allToleranceData?.find(({ _id }) => _id == props.singleValue?.cncTolerance)?.cnc_tolerance;
      setToleranceName(name);
    }
  }, [props.singleValue?.cncTolerance, allToleranceData]);
  useEffect(() => {
    if (Array.isArray(reviewDesign) && props.singleValue?.cncReviewMyDesign) {
      const val = reviewDesign?.find(({ _id }) => _id == props.singleValue?.cncReviewMyDesign)?.cnc_review_my_design;
      setReviewMyDesign(val ? 'Yes' : 'No');
    }
  }, [props.singleValue?.cncReviewMyDesign, reviewDesign]);
  useEffect(() => {
    if (Array.isArray(partMarking) && props.singleValue?.cncPartMarking) {
      const val = partMarking?.find(({ _id }) => _id == props.singleValue?.cncPartMarking)?.cnc_part_marking;
      setPartMarkingName(val ? 'Yes' : 'No');
    }
  }, [props.singleValue?.cncPartMarking, partMarking]);
  useEffect(() => {
    if (Array.isArray(internalCorner) && props.singleValue?.cncInternalCorner) {
      const val = internalCorner?.find(({ _id }) => _id == props.singleValue?.cncInternalCorner)?.cnc_internal_corner;
      setInternalCornerName(val);
    }
  }, [props.singleValue?.cncInternalCorner, internalCorner]);
  //threeD
  useEffect(() => {
    if (Array.isArray(threeDTechnologyData) && props?.singleValue?.threeDTechnology) {
      const val = threeDTechnologyData?.find(({ _id }) => _id == props?.singleValue?.threeDTechnology)?.name;
      val && setThreeDTechnologyName(val);
    }
  }, [props?.singleValue?.threeDTechnology, threeDTechnologyData]);
  useEffect(() => {
    if (Array.isArray(materialData) && props.singleValue?.threeDMaterial) {
      const name = materialData?.find(({ _id }) => _id == props.singleValue?.threeDMaterial)?.name;
      name && setThreeDMaterialName(name);
    }
  }, [props.singleValue?.threeDMaterial, materialData]);
  useEffect(() => {
    if (Array.isArray(surfaceFinishData) && props.singleValue?.threeDPostProcessing) {
      console.log("Post Process Id :", props.singleValue?.threeDPostProcessing);
      console.log("Post Processing Data :", surfaceFinishData);
      const name = surfaceFinishData?.find(({ _id }) => _id == props.singleValue?.threeDPostProcessing)?.name;
      if (name) {

        setThreeDPostProcessName(name);
      }
    }
  }, [props.singleValue?.threeDPostProcessing, surfaceFinishData]);

  // const [threeDTechnologyName, setThreeDTechnologyName] = useState('');
  // const [threeDMaterialName, setThreeDMaterialName] = useState('');
  // const [threeDPostProcessName, setThreeDPostProcessName] = useState('');

  console.log('3D Technology:', threeDTechnologyName);
  console.log('3D Material:', threeDMaterialName);
  console.log('3D Post Processing:', threeDPostProcessName);


  //error useEffect
  useEffect(() => {
    console.log("Props :", props);
    if (!Array.isArray(props.cncAllMachineDataResponse)) return;
    (async () => {
      try {
        props.setIsGlobeLoader(true)
        const data = props.cncAllMachineDataResponse;
        console.log("Cnc Machine Data :", data);
        let selectedMachine;
        if (props?.singleValue?.stagingPartsDataId?.type?.toLowerCase() == 'CNC_MILLING'?.toLowerCase()) {
          selectedMachine = data?.find((item) => item?.cnc_machine?.toLowerCase() == 'CNC_MILLING'?.toLowerCase())
        }
        else if (props?.singleValue?.stagingPartsDataId?.type?.toLowerCase() == 'CNC_LATHE'?.toLowerCase() || props?.singleValue?.stagingPartsDataId?.type?.toLowerCase() == 'CNC_LATHE_MILLING'?.toLowerCase()) {
          selectedMachine = data?.find((item) => item?.cnc_machine == 'CNC_LATHE')
        }
        else {
          selectedMachine = data?.find((item) => item.cnc_machine?.toLowerCase() == 'outOfSpec'.toLowerCase());
        }
        // console.log("Selected Machine For Cnc :", selectedMachine);
        setSelectedMachineData(selectedMachine);
        setIsCncDropDownLoading(false);
        props.setIsGlobeLoader(false)

      } catch (error) {
        console.log('Error at the following', error)
        toast.error("Failed to fetch CNC machines data. Please refresh and try again.");
        props.setIsGlobeLoader(false)
      }
    })()


  }, [props?.singleValue?.stagingPartsDataId?.type])

  //cnc use Effect Start
  useEffect(() => {
    // console.log('came here ...', props?.selectedProcess)
    if (!props?.selectedProcess || props?.selectedProcess == 2) return;
    // console.log('selectedMachineData', selectedMachineData)
    if (selectedMachineData) {
      const materialGradeObject = {};
      const materials = selectedMachineData?.cnc_materials;
      if (Array.isArray(materials)) {
        materials.forEach((item) => {
          const materialName = item?.cnc_material;
          const materialGrade = item?.cnc_grade;

          if (!materialGradeObject[materialName]) {
            materialGradeObject[materialName] = [];
          }
          if (materialGrade && !materialGradeObject[materialName].includes(materialGrade)) {
            materialGradeObject[materialName].push(materialGrade);
          }
        });
        const sortedMaterialGradeObject = Object.keys(materialGradeObject)
          .sort() // Sort the keys alphabetically
          .reduce((sortedObj, key) => {
            // Sort the values of each key alphabetically
            sortedObj[key] = materialGradeObject[key].sort((a, b) => a.localeCompare(b));
            return sortedObj;
          }, {});
        setMaterialGradeData(sortedMaterialGradeObject);
        if (!props.singleValue.cncMaterial) {
          const firstKey = 'Aluminum';
          setSelectedMaterialName(firstKey);
        } else {
          let selectedMaterial = materials.find(material => material?._id === props.singleValue.cncMaterial);
          console.log('selectedMaterial', selectedMaterial?.cnc_material)
          setSelectedMaterialName(selectedMaterial.cnc_material)
        }
        //selected first key
      }
    }
  }, [props?.isMaterialChangeForAllFields, selectedMachineData, props?.selectedProcess, props.cncAllMachineDataResponse]);


  //cnc use Effect Start
  useEffect(() => {
    if (!props?.selectedProcess || props?.selectedProcess == 2) return;
    console.log('selectedMaterialName', selectedMaterialName)
    if (selectedMaterialName) {
      if (props.sameForAllField || (refForSelectingGradeOnFirstLoad.current && props.singleValue.cncMaterial)) {
        refForSelectingGradeOnFirstLoad.current = false;
        const materials = selectedMachineData?.cnc_materials;
        const selectedMaterial = materials.find((item) => item?._id == props.singleValue.cncMaterial);
        setSelectedGradeName(selectedMaterial?.cnc_grade)
      } else {

        const grade = materialGradeData[selectedMaterialName][0];
        console.log(props.index, 'grade: ' + grade)
        if (grade) {
          setSelectedGradeName(grade);
        }
      }
    }

  }, [props?.isMaterialChangeForAllFields, selectedMaterialName, props?.selectedProcess]);


  useEffect(() => {

    if (selectedMachineData) {
      const materials = selectedMachineData?.cnc_materials;

      if (materials && Array.isArray(materials)) {
        for (const item of materials) {
          const materialName = item?.cnc_material;
          const materialGrade = item?.cnc_grade;

          if (materialName == selectedMaterialName && selectedGradeName == materialGrade) {
            console.log("Material :", item);
            if (item?._id) {
              handleOptionChange(1, item?._id);
            }
            break;
          }
        }
      }
    }


  }, [selectedGradeName, props.selectedProcess]);





  useEffect(() => {
    // console.log("CNC Material:", props.singleValue.cncMaterial);
    // console.log("Selected Machine Data:", selectedMachineData);
    // console.log("CNC Heat Treatment:", props.singleValue.cncHeatTreatment);
    // console.log("CNC Internal Corner:", props.singleValue.cncInternalCorner);
    // console.log("CNC Park Marking:", props.singleValue.cncPartMarking);
    // console.log("CNC Review My Design:", props.singleValue.cncReviewMyDesign);
    // console.log("CNC Surface Finish:", props.singleValue.cncSurfaceFinish);
    // console.log("CNC Tolerance:", props.singleValue.cncTolerance);
    if (!props?.selectedProcess || props?.selectedProcess == 2 || props?.selectedProcess >= 3) return;
    if (props?.singleValue?.cncMaterial
      && selectedMachineData
    ) {

      const materials = selectedMachineData?.cnc_materials;
      if (materials && Array.isArray(materials)) {
        const selectedMaterial = materials.find((item) => item?._id == props?.singleValue?.cncMaterial);
        // console.log("Selected Material :", selectedMaterial);
        if (selectedMaterial) {
          console.log("isCncMaterialChangedByDropDown", isCncMaterialChangedByDropDown);
          const allSurfaceFinishData = selectedMaterial?.cnc_surface_finish;
          const allHeatTreatMentData = selectedMaterial?.cnc_heat_treatment;
          const allToleranceData = selectedMaterial?.cnc_tolerance;
          const allInternalCornerData = selectedMaterial?.cnc_internal_corners;
          const allReviewDesignData = selectedMaterial?.cnc_review_my_design;
          const allPartMarkingData = selectedMaterial?.cnc_part_marking;

          //setting data 
          allSurfaceFinishData && setSurfaceFinish(allSurfaceFinishData);
          allSurfaceFinishData.sort((a, b) => {
            return a.cnc_surface_finish.localeCompare(b.cnc_surface_finish);
          });
          const firstSfItem = allSurfaceFinishData.find((item) => item?.cnc_surface_finish?.toLocaleLowerCase() == 'As machined'.toLocaleLowerCase()) || allSurfaceFinishData[0];
          handleOptionChange(3, (!isCncMaterialChangedByDropDown && quoteId && props?.singleValue?.cncSurfaceFinish) ? props?.singleValue?.cncSurfaceFinish : firstSfItem?._id);


          allHeatTreatMentData && setHeatTreatMent(allHeatTreatMentData);
          // cnc_heat_treatment
          allHeatTreatMentData.sort((a, b) => {
            return a.cnc_heat_treatment.localeCompare(b.cnc_heat_treatment);
          });
          const firstHeatTreatMentItem = allHeatTreatMentData.find((item) => item?.cnc_heat_treatment?.toLocaleLowerCase() == 'Not Required'.toLocaleLowerCase()) || allHeatTreatMentData[0];
          handleOptionChange(4, (!isCncMaterialChangedByDropDown && quoteId && props?.singleValue?.cncHeatTreatment) ? props?.singleValue?.cncHeatTreatment : firstHeatTreatMentItem?._id);



          allToleranceData && setAllToleranceData(allToleranceData);
          // cnc_tolerance
          allToleranceData.sort((a, b) => {
            return a.cnc_tolerance.localeCompare(b.cnc_tolerance);
          });


          const firstToleranceItem = allToleranceData.find(item => item.cnc_tolerance.toLowerCase().includes("medium")) || allToleranceData[0];

          handleOptionChange(5, (!isCncMaterialChangedByDropDown && quoteId && props?.singleValue?.cncTolerance) ? props?.singleValue?.cncTolerance : firstToleranceItem?._id);
          if ((!isCncMaterialChangedByDropDown && quoteId && props?.singleValue?.cncTolerance)) {
            //check if two file is required or not
            const selectedTolerance = allToleranceData.find(item => item?._id == props?.singleValue?.cncTolerance);
            if (selectedTolerance?.cnc_tol_2D_dwg_required) {
              handleTwoDDrawingRequiredChange(true);
            }
            else {
              handleTwoDDrawingRequiredChange(false);
            }
          }
          allInternalCornerData && setInternalCorner(allInternalCornerData);
          // cnc_internal_corner
          // allInternalCornerData.sort((a, b) => {
          //   return a.cnc_internal_corner.localeCompare(b.cnc_internal_corner);
          // });

          // console.log('allInternalCornerData', allInternalCornerData)

          const firstInternalCornerItem = allInternalCornerData.find(item => item.cnc_internal_corner.toLowerCase().includes("2mm")) || allInternalCornerData[0];

          handleOptionChange(7, (!isCncMaterialChangedByDropDown && quoteId && props?.singleValue?.cncInternalCorner) ? props?.singleValue?.cncInternalCorner : firstInternalCornerItem?._id);

          allReviewDesignData && setReviewDesign(allReviewDesignData);


          const firstReviewDesignData = allReviewDesignData.find(item => item.cnc_design_review == false);

          handleOptionChange(6, (!isCncMaterialChangedByDropDown && quoteId && props?.singleValue?.cncReviewMyDesign) ? props?.singleValue?.cncReviewMyDesign : firstReviewDesignData?._id);

          allPartMarkingData && setPartMarking(allPartMarkingData);


          const firstPartMarkingData = allPartMarkingData.find(item => item.cnc_part_marking == false);

          handleOptionChange(15, (!isCncMaterialChangedByDropDown && quoteId && props?.singleValue?.cncPartMarking) ? props?.singleValue?.cncPartMarking : firstPartMarkingData?._id);

        }
      }
    }

  }, [props?.singleValue?.cncMaterial,
    selectedMachineData, props?.selectedProcess
    , isCncMaterialChangedByDropDown,
    ,]);
  //threeD useEffect Start
  useEffect(() => {
    if (!props?.selectedProcess || props?.selectedProcess == 1) return;
    if (threeDTechnologyData && Array.isArray(threeDTechnologyData) && threeDTechnologyData.length) {
      const allMaterialSet = {}
      const surfaceFinishData = {}

      threeDTechnologyData.forEach((tech) => {
        const { machines } = tech;
        if (machines && Array.isArray(machines)) {
          machines.forEach((machine) => {
            const { materials } = machine;
            if (materials && Array.isArray(materials)) {
              materials.forEach((material) => {
                let { name, postProcess } = material;
                name.trim();
                if (!allMaterialSet[name]) {
                  allMaterialSet[name] = material;
                }
                if (postProcess && Array.isArray(postProcess)) {
                  postProcess.forEach((postProcess) => {
                    let { name } = postProcess;
                    name.trim();
                    if (!surfaceFinishData[name]) {
                      surfaceFinishData[name] = postProcess;
                    }
                  })
                }
              })
            }

          })


        }
      })
      setAllMaterialData(Object.values(allMaterialSet));
      setAllSurfaceFinishData(Object.values(surfaceFinishData));
    }

  }, [threeDTechnologyData, props?.selectedProcess]);


  useEffect(() => {
    if (!props?.selectedProcess || props?.selectedProcess == 1 || props?.selectedProcess >= 3) return;


    if (!props?.singleValue?.threeDTechnology && !props?.singleValue?.threeDMachine && !props.singleValue?.threeDMaterial) {
      const x = Math.abs(props?.singleValue?.stagingPartsDataId?.bboxDx_mm)
      const y = Math.abs(props?.singleValue?.stagingPartsDataId?.bboxDy_mm)
      const z = Math.abs(props?.singleValue?.stagingPartsDataId?.bboxDz_mm)

      console.log('X Dim is :', x);
      console.log('Y Dim is :', y);
      console.log("Z Dim is :", z);


      let isFoundTech = false;

      if (x && y && z) {
        // Create a local copy and sort it to bring "mjf" to the first position
        const sortedTechnologyData = [...threeDTechnologyData].sort((a, b) => {
          return a.name?.toLowerCase() === "mjf" ? -1 : b.name?.toLowerCase() === "mjf" ? 1 : 0;
        });

        OuterLoop:
        for (const tech of sortedTechnologyData) {
          const { machines, _id } = tech;
          for (const machine of machines) {
            const { dimensions: { xDim, yDim, zDim } } = machine;
            const machinesDimensions = [xDim, yDim, zDim];
            machinesDimensions.sort((a, b) => a - b);
            const partsDimensions = [x, y, z].map(parseFloat);

            partsDimensions.sort((a, b) => a - b);
            console.log('machinesDimensions', machinesDimensions);
            console.log('partsDimensions', partsDimensions);

            if (
              machinesDimensions[0] >= partsDimensions[0]
              && machinesDimensions[1] >= partsDimensions[1]
              && machinesDimensions[2] >= partsDimensions[2]
            ) {
              console.log('3D auto mjf selected')
              props.updateValueOnChange(
                props.index,
                "threeDTechnology",
                _id,
                getFileExtension(props?.singleValue?.selectedFile?.originalname)
              );
              props.updateValueOnChange(
                props.index,
                "isOutOfSpec",
                false,
              );
              isFoundTech = true;
              break OuterLoop;
            }
          }
        };

        console.log("Is found machine ::", isFoundTech);
        if (!isFoundTech) {
          const sortedTechnologyData = [...threeDTechnologyData].sort((a, b) => {
            return a.name?.toLowerCase() === "sla" ? -1 : b.name?.toLowerCase() === "sla" ? 1 : 0;
          });

          OuterLoop:
          for (const tech of sortedTechnologyData) {
            const { machines, _id } = tech;
            for (const machine of machines) {
              const { dimensions: { xDim, yDim, zDim } } = machine;
              const machinesDimensions = [xDim, yDim, zDim];
              machinesDimensions.sort((a, b) => a - b);
              const partsDimensions = [x, y, z].map(parseFloat);

              partsDimensions.sort((a, b) => a - b);
              console.log('machinesDimensions', machinesDimensions);
              console.log('partsDimensions', partsDimensions);

              if (
                machinesDimensions[0] >= partsDimensions[0]
                && machinesDimensions[1] >= partsDimensions[1]
                && machinesDimensions[2] >= partsDimensions[2]
              ) {
                console.log('3D auto SLA selected')
                props.updateValueOnChange(
                  props.index,
                  "threeDTechnology",
                  _id,
                  getFileExtension(props?.singleValue?.selectedFile?.originalname)
                );
                props.updateValueOnChange(
                  props.index,
                  "isOutOfSpec",
                  false,
                );
                isFoundTech = true;
                break OuterLoop;
              }
            }
          }
        }


      }

      console.log("isFoundTech", isFoundTech);

      if (!isFoundTech) {
        props.updateValueOnChange(
          props.index,
          "isOutOfSpec",
          true,
        );
      }
    }
  }, [threeDTechnologyData, props?.selectedProcess]);




  useEffect(() => {
    if (!props?.selectedProcess || props?.selectedProcess == 1 || props?.selectedProcess >= 3) return;
    if (props?.singleValue?.threeDTechnology) {
      const selectedTechnology = threeDTechnologyData.find(({ _id }) => _id == props?.singleValue?.threeDTechnology);
      if (!selectedTechnology) return; // check this with pratyush
      const { machines } = selectedTechnology;
      console.log("Selcted Technology ", selectedTechnology);
      const materialSet = {};
      let selectedThreeDMachine = null;

      console.log("Selected Machine :", selectedThreeDMachine);


      const x = Math.abs(props?.singleValue?.stagingPartsDataId?.bboxDx_mm)

      const y = Math.abs(props?.singleValue?.stagingPartsDataId?.bboxDy_mm)

      const z = Math.abs(props?.singleValue?.stagingPartsDataId?.bboxDz_mm);

      const volumeInCC = parseFloat(Number(props?.singleValue?.stagingPartsDataId?.totalVolume_mm3) / 1000);
      // First, try to find a matching machine
      for (const machine of machines || []) {
        const { materials } = machine;
        const { dimensions: { xDim, yDim, zDim }, _id: machineId } = machine;
        const machinesDimensions = [xDim, yDim, zDim].sort((a, b) => a - b);
        const partsDimensions = [x, y, z].sort((a, b) => a - b);

        const fits =
          machinesDimensions[0] >= partsDimensions[0] &&
          machinesDimensions[1] >= partsDimensions[1] &&
          machinesDimensions[2] >= partsDimensions[2];

        if (fits) {
          console.log("Machine Id :", machineId);
          console.log("Machines Dimensions :", machinesDimensions);
          selectedThreeDMachine = machineId;

          materials?.forEach((material) => {
            const nameOfMaterial = material?.name;
            if (!materialSet[nameOfMaterial]) {
              materialSet[nameOfMaterial] = material;
            }
          });

          break; // Stop after finding the first fit
        }
      }

      // If no matching machine found, find an out-of-spec machine
      if (!selectedThreeDMachine) {
        for (const machine of machines || []) {
          const { materials } = machine;
          const { dimensions: { xDim, yDim, zDim }, _id: machineId } = machine;
          const machinesDimensions = [xDim, yDim, zDim];

          const isOutOfSpecCandidate =
            props?.singleValue?.isOutOfSpec === true &&
            (machinesDimensions[0] === 0 ||
              machinesDimensions[1] === 0 ||
              machinesDimensions[2] === 0);

          if (isOutOfSpecCandidate) {
            console.log("Selected Out-of-Spec Machine Id :", machineId);
            console.log("Machines Dimensions :", machinesDimensions);
            selectedThreeDMachine = machineId;

            materials?.forEach((material) => {
              const nameOfMaterial = material?.name;
              if (!materialSet[nameOfMaterial]) {
                materialSet[nameOfMaterial] = material;
              }
            });

            break; // Stop after selecting the first out-of-spec machine
          }
        }
      }

      console.log("Material set :", materialSet);
      console.log("Selected Three D Machine :", selectedThreeDMachine);

      const allMaterial = Object.values(materialSet);
      console.log("All Materials :", allMaterial);
      // const firstMaterialId = allMaterial[0]?._id;
      const firstMaterialId = (!lockRefForThreeD.current && props?.singleValue?.threeDMaterial) ? props?.singleValue?.threeDMaterial : allMaterial[0]?._id;
      console.log("First Material Id 2 :", firstMaterialId);
      console.log("Preview Id :", props?.singleValue?.threeDMaterial);
      props.updateValueOnChange(
        props.index,
        "threeDMachine",
        // selectedThreeDMachine,
        (!lockRefForThreeD.current && props?.singleValue?.threeDMachine) ? props?.singleValue?.threeDMachine : selectedThreeDMachine,
      );
      props.updateValueOnChange(
        props.index,
        "threeDMaterial",
        firstMaterialId,
      );
      allMaterial.sort((a, b) => a.name.localeCompare(b.name));
      setMaterialData(allMaterial);
      if (
        x && y && z && volumeInCC
      ) {
        let localValues = [...props.values];
        let updatedValues = localValues.map((item, idx) => {
          if (idx == props.index) {
            item.XDimensionValue = x;
            item.YDimensionValue = y;
            item.ZDimensionValue = z;
            item.partVolume = volumeInCC;
          }
          return item;
        });
        props.setValues(updatedValues, createQuoteDispatch, createQuoteState)
      }

    }
    // else if (props?.singleValue?.threeDTechnology && threeDTechnologyData.length) {
    //   const selectedTechnology = threeDTechnologyData.find(({ _id }) => _id == props?.singleValue?.threeDTechnology);
    //   // console.log("Selected Technology", selectedTechnology);
    //   const { machines } = selectedTechnology;
    //   const materialSet = {};
    //   machines?.forEach((machine) => {
    //     const { materials } = machine;
    //     materials?.forEach((material) => {
    //       const nameOfMaterial = material?.name;
    //       (!materialSet[nameOfMaterial]) && (materialSet[nameOfMaterial] = material);
    //     })

    //   });
    //   const selectedThreeDMachine = machines[0]?._id;
    //   const allMaterial = Object.values(materialSet);
    //   const firstMaterialId = allMaterial[0]?._id;
    //   console.log("First Material Id 1 :", firstMaterialId);
    //   console.log("Preview Id :", props?.singleValue?.threeDMaterial);

    //   props.updateValueOnChange(
    //     props.index,
    //     "threeDMachine",
    //     selectedThreeDMachine,
    //   );
    //   props.updateValueOnChange(
    //     props.index,
    //     "threeDMaterial",
    //     firstMaterialId,
    //   );
    //   allMaterial.sort((a, b) => a.name.localeCompare(b.name));
    //   setMaterialData(allMaterial);
    // }

  }, [props?.singleValue?.threeDTechnology, props?.singleValue?.isOutOfSpec, threeDTechnologyData, props?.selectedProcess]);

  useEffect(() => {
    if (!props?.selectedProcess || props?.selectedProcess == 1 || props?.selectedProcess >= 3) return;
    if (props?.singleValue?.threeDMaterial) {
      // console.log('ThreeDMaterial :', props?.singleValue?.threeDMaterial);
      const materialId = props?.singleValue?.threeDMaterial;
      const techId = props?.singleValue?.threeDTechnology;
      let postProcessData = [];

      const selectedTech = threeDTechnologyData?.find(({ _id }) => _id == techId);
      selectedTech?.machines?.forEach((machine) => {
        const { materials } = machine;
        materials?.forEach((material) => {
          if (material?._id == materialId) {
            const { postProcess } = material;
            postProcessData = postProcess;
          }
        })
      })
      if (postProcessData.length) {
        // console.log("Post Data", postProcessData);
        if (!isPostProcessThreeDChangedByDropDown && props?.singleValue?.threeDPostProcessing) {
          props.updateValueOnChange(
            props.index,
            "threeDPostProcessing",
            props?.singleValue?.threeDPostProcessing
          );
          const allPostProcess = postProcessData;
          allPostProcess.sort((a, b) => a.name.localeCompare(b.name));

          setSurfaceFinishData(allPostProcess);
        }
        else {
          const allPostProcess = postProcessData;
          const firstPostProcessObject = allPostProcess?.sort((a, b) => a.name.localeCompare(b.name))[0];
          const firstPostProcessData = firstPostProcessObject?._id;
          props.updateValueOnChange(
            props.index,
            "threeDPostProcessing",
            firstPostProcessData
          );
          allPostProcess.sort((a, b) => a.name.localeCompare(b.name));

          setSurfaceFinishData(allPostProcess);

        }

      }

    }
  }, [props?.singleValue?.threeDMaterial, props?.singleValue?.isOutOfSpec, props?.selectedProcess, threeDTechnologyData, isPostProcessThreeDChangedByDropDown]);





  useEffect(() => {
    if (!props?.selectedProcess || props?.selectedProcess == 1 || props?.selectedProcess >= 3) return;
    if (props?.singleValue?.isOutOfSpec) {
      console.log("stage a");


      const updatedTechData = masterThreeDTechnologyData?.map((tech) => {
        const { machines } = tech;

        const filteredMachines = machines.filter(({ dimensions: { xDim, yDim, zDim } }) => {
          return xDim == 0 && yDim == 0 && zDim == 0;
        });
        if (filteredMachines.length) {
          return { ...tech, machines: filteredMachines };
        };
        return null;

      }).filter((item) => item != null);




      if (updatedTechData?.length) {
        console.log("stage b");
        const firstTechId = props?.singleValue?.threeDTechnology ? props?.singleValue?.threeDTechnology : updatedTechData[0]?._id;
        const selectedThreeDMachine = props?.singleValue?.threeDMachine ? props?.singleValue?.threeDMachine : updatedTechData[0].machines[0]?._id;
        const selectedMaterial = props?.singleValue?.threeDMaterial;
        const selectedThreeDPostProcess = props?.singleValue?.threeDPostProcessing;
        console.log("Selected Material Process :", selectedMaterial);
        console.log("Selected Three D Post Process :", selectedThreeDPostProcess);
        props.updateValueOnChange(
          props.index,
          "threeDTechnology",
          firstTechId,
        );
        props.updateValueOnChange(
          props.index,
          "threeDMachine",
          selectedThreeDMachine,
        );
        if (selectedMaterial) {
          props.updateValueOnChange(
            props.index,
            "threeDMaterial",
            selectedMaterial,
          );
        }
        if (selectedThreeDPostProcess) {
          props.updateValueOnChange(
            props.index,
            "threeDPostProcessing",
            selectedThreeDPostProcess,
          );
        }
      }


      console.log("Updated Tech Data In UseEffect Out of Spec Is True :", updatedTechData);
      updatedTechData.sort((a, b) => a.name.localeCompare(b.name));

      setThreeDTechnologyData(updatedTechData);
    }
    else if (!props.singleValue?.isOutOfSpec) {
      const updatedTechData = masterThreeDTechnologyData?.map((tech) => {
        const { machines } = tech;

        const filteredMachines = machines.filter(({ dimensions: { xDim, yDim, zDim } }) => {
          return xDim != 0 && yDim != 0 && zDim != 0;
        });
        if (filteredMachines.length) {
          return { ...tech, machines: filteredMachines };
        };
        return null;

      }).filter((item) => item != null);

      console.log("Updated Tech Data In UseEffect Out of Spec Is false :", updatedTechData);
      updatedTechData.sort((a, b) => a.name.localeCompare(b.name));

      setThreeDTechnologyData(updatedTechData);
    }
  }, [props?.singleValue?.isOutOfSpec, props?.selectedProcess]);

  //check twoD Drawing Required For tolerance
  const handleTwoDDrawingRequiredChange = (value) => {
    try {
      let percent = 0;
      props.updateValueOnChange(props.index, "twoDFileRequired", value);
    } catch (err) {
      return err;
    }
  };


  useEffect(() => {
    if (Array.isArray(allToleranceData) && props.singleValue?.cncTolerance && props.selectedProcess == 1) {
      const selectedTolerance = allToleranceData.find((item) => item?._id === props.singleValue?.cncTolerance);
      console.log("Selected tolerance in automate process ::", selectedTolerance);
      if (selectedTolerance?.cnc_tol_2D_dwg_required) {
        handleTwoDDrawingRequiredChange(true);
      }
      else {
        handleTwoDDrawingRequiredChange(false);
      }

    }
    else {
      handleTwoDDrawingRequiredChange(false);
    }

  }, [props.singleValue?.cncTolerance, allToleranceData, isGlobalLoading, props.selectedProcess])

  let indexFor2DFiles = props.index;



  const handleQtyChange = (value) => {
    try {
      const isEmpty = value === "";
      const isNaturalNumber = /^[1-9][0-9]*$/.test(value);
      if (!isEmpty && !isNaturalNumber) {
        return;
      }
      let percent = 0;
      props.updateValueOnChange(props.index, "Qty", value, percent);
    } catch (err) {
      return err;
    }
  };


  const handle2DFileUpload = async (e) => {
    try {
      const file = e.target.files[0];

      if (!file) {
        console.log("No file uploaded");
        return;
      }

      if (!quoteId) {
        toast.error("Invalid quotation. Please refresh the page and try again.");
        return;
      }

      const fileSizeInMB = file.size / (1024 * 1024);

      if (file.size < 1024 || fileSizeInMB > 100) {
        toast.error("File size must be between 1 KB and 100 MB.");
        return;
      };

      console.log("Uploaded File Is:", file);
      setIsTwoDFileUploading(true);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("quoteId", quoteId);
      formData.append("indexOfPartsData", indexFor2DFiles);
      const response = await uploadTwoDFile(formData);

      if (!response || !response.success) {
        toast.error("Failed to upload file. Please try again.");
        return;
      };
      toast.success("File uploaded successfully");

      const { data } = response;
      props.updateValueOnChange(indexFor2DFiles, 'twoDFile', data);

    } catch (err) {
      console.log("Error:", err);
    } finally {
      setIsTwoDFileUploading(false);
    }
  };

  const handleThreeDFileUploading = async (e) => {
    try {
      const file = e.target.files[0];

      if (!file) {
        console.log("No file uploaded");
        return;
      }

      if (!quoteId) {
        toast.error("Invalid quotation. Please refresh the page and try again.");
        return;
      }

      const val = await props?.handleThreeDFileUpload(file, indexFor2DFiles);
      console.log('Value ::', val);

      // console.log("Uploaded File Is:", file);
      // setIsThreeDFileUploading(true);
      // const formData = new FormData();
      // formData.append("file", file);
      // formData.append("quoteId", quoteId);
      // formData.append("indexOfPartsData", indexFor2DFiles);
      // const response = await uploadTwoDFile(formData);

      // if (!response || !response.success) {
      //   toast.error("Failed to upload file. Please try again.");
      //   return;
      // };
      // toast.success("File uploaded successfully");

      // const { data } = response;
      // props.updateValueOnChange(indexFor2DFiles, 'twoDFile', data);

    } catch (err) {
      console.log("Error:", err);
    } finally {
      setIsThreeDFileUploading(false);
    }
  };


  const handleDelete2DFiles = async () => {
    try {
      const bodyData = {
        quoteId,
        indexOfPartsData: indexFor2DFiles,
      }
      const response = await deleteTwoDFile(bodyData);
      if (!response || !response.success) {
        throw new Error();
      }
      const { data } = response;
      toast.success("File deleted successfully");
      props.updateValueOnChange(indexFor2DFiles, 'twoDFile', null);

    } catch (error) {
      toast.error("Failed to delete file. Please try again.");
    }
  };





  let getFileExtension = (filename) => {
    return filename?.slice(((filename?.lastIndexOf(".") - 1) >>> 0) + 2);
  };





  const fetchDataFromApi = (endPoint, payload = []) => {
    console.log("fetchDataFromApi", endPoint, payload);
    return new Promise(async (resolve, reject) => {
      try {
        console.log('cam ehr eddf')
        const response = await fetchApi(endPoint, payload, token);
        if (!response && !response.status) {
          throw { message: response.message || "Something went wrong" };
        }
        return resolve(response.data);
      } catch (err) {
        return reject(err);
      }
    });
  };

  const handleOptionChange = (type, value) => {
    try {
      switch (type) {

        case 1:
          props.updateValueOnChange(
            props.index,
            "cncMaterial",
            value,
            getFileExtension(props?.singleValue?.selectedFile?.originalname)
          );
          break;
        case 3:
          props.updateValueOnChange(
            props.index,
            "cncSurfaceFinish",
            value,
            getFileExtension(props?.singleValue?.selectedFile?.originalname)
          );

          break;
        case 4:
          props.updateValueOnChange(
            props.index,
            "cncHeatTreatment",
            value,
            getFileExtension(props?.singleValue?.selectedFile?.originalname)
          );

          break;
        case 5:
          props.updateValueOnChange(
            props.index,
            "cncTolerance",
            value,
            getFileExtension(props?.singleValue?.selectedFile?.originalname)
          );

          break;
        case 6:
          props.updateValueOnChange(
            props.index,
            "cncReviewMyDesign",
            value,
            getFileExtension(props?.singleValue?.selectedFile?.originalname)
          );

          break;
        case 7:
          props.updateValueOnChange(
            props.index,
            "cncInternalCorner",
            value,
            getFileExtension(props?.singleValue?.selectedFile?.originalname)
          );

          break;
        case 8:
          //Old logic to hanlde same for all fields
          // props.updateCommanValueOnChange(
          //   "sameForAllField",
          //   !props?.sameForAllField,
          //   getFileExtension(props?.singleValue?.selectedFile?.originalname)
          // );

          break;
        case 10:
          props.updateValueOnChange(
            props.index,
            "finalCost",
            value,
            getFileExtension(props?.singleValue?.selectedFile?.originalname)
          );
          break;

        case 11:
          props.updateValueOnChange(
            props.index,
            "threeDTechnology",
            value,
            getFileExtension(props?.singleValue?.selectedFile?.originalname)
          );

          break;
        case 12:
          props.updateValueOnChange(
            props.index,
            "threeDMachine",
            value,
            getFileExtension(props?.singleValue?.selectedFile?.originalname)
          );
          break;

        case 13:
          props.updateValueOnChange(
            props.index,
            "threeDMaterial",
            value,
            getFileExtension(props?.singleValue?.selectedFile?.originalname)
          );
          break;

        case 14:
          props.updateValueOnChange(
            props.index,
            "threeDPostProcessing",
            value,
            getFileExtension(props?.singleValue?.selectedFile?.originalname)
          );
          break;
        case 15:
          props.updateValueOnChange(
            props.index,
            "cncPartMarking",
            value,
            getFileExtension(props?.singleValue?.selectedFile?.originalname)
          );
          break;
        case 16:
          {
            props.updateValueOnChange(
              props.index,
              "cncMaterialName",
              value);
          }

          break;
        default:
          break;
      }
    } catch (err) {
      return err;
    }
  };

  useEffect(() => {
    try {
      if (
        props.singleValue.algorithmPrice &&
        props.singleValue.partMarking &&
        props.singleValue.partMarking !== ""
      ) {
        handleOptionChange(10);
      }
    } catch (err) {
      console.log(err);
    }
  }, [props.singleValue.partMarking, props.singleValue.noOfThread]);



  const isValidFileName = (name) => {
    const type = getFileExtension(name)?.toUpperCase();
    if (
      type === "STP" ||
      type === "STEP" ||
      // type === "IGES" ||
      // type === "OBJ" ||
      type === "STL"
    )
      return true;

    return false;
  };

  const isAnyProcessEditingActivated = (isEditingActivatedCnc || isEditingActivatedThreeD);


  const isValidFileForPricing = (name) => {
    const type = getFileExtension(name)?.toUpperCase();
    if (
      type === "STP" ||
      type === "STEP"
    ) return true;
    console.log("File is :", false);
    return false;
  };
  const moveLineItemToXindex = (index, direction) => {
    // 1
    //   - 1


    const values = createQuoteState?.values;
    const tempValue = JSON.parse(JSON.stringify(values[index + direction]))

    console.log("Values To Change :", values[index]);
    values[index + direction] = values[index];
    values[index] = tempValue;
    setValues([...values], createQuoteDispatch, createQuoteState);
    const updatedCommanValues = { ...createQuoteState?.commanValues };
    updatedCommanValues.isQuoteChanged = true;
    createQuoteDispatch({
      type: CREATE_QUOTE_ACTION.UPDATE_COMMAN_VALUES,
      payload: updatedCommanValues,
    });
  }

  useEffect(() => {
    let localFiles = props.values.map((item) => {
      return item.file || item.selectedFile;
    });
    props.setFiles(localFiles);
  }, []);
  const handleThreeDFileDownloading = async (bucketObj) => {
    try {
      setIsThreeDFileDownloading(true);
      const { originalname } = bucketObj;
      if (originalname && originalname.endsWith('.pdf')) {
        const signedUrl = await getPresignedUrlForFile(bucketObj.bucket, bucketObj.key);
        console.log('Signed URL for PDF:', signedUrl);
        setPdfModalInfo({
          show: true,
          pdfUrl: signedUrl,
          fileName: originalname,
        })
        return;

      }
      await downloadFileFromS3(bucketObj)

    } catch (error) {
      toast.error("")
    } finally {
      setIsThreeDFileDownloading(false);
    }
  }
  console.log('Surface Finish:', surfaceFinishName);
  console.log('Heat Treatment:', headTreatmentName);
  console.log('Tolerance:', toleranceName);
  console.log('Review My Design:', reviewMyDesignName);
  console.log('Part Marking:', partMarkingName);
  console.log('Internal Corner:', internalCornerName);

  const showDownload = props.singleValue?.selectedFile?.originalname
    || props.singleValue?.selectedFile?.name;



  return (
    <div
      className={`item-card  flex justify-between min-h-36   `}
      onClick={() => {
        lockRefForThreeD.current = true;
      }
      }
    >
      <AntModal
        open={isOpenDeleteFileModal}

        onCancel={() => {
          setDeleteConfirm(false);
        }}
        footer={null}
        closable={false}
        centered
        width={400}
        title={
          <div className="flex items-center gap-2 text-lg font-semibold text-red-600">
            <ExclamationCircleOutlined className="text-red-500 text-xl" />
            Confirm
          </div>
        }

      >
        <div className="text-gray-700 text-base mb-6">
          <span>Are you sure you want to delete</span>
          <span className="font-medium mx-2">
            {(props.singleValue?.selectedFile?.originalname ||
              props.singleValue?.selectedFile?.name || props.singleValue?.linePartName ||
              'SamplePart.stp')
              .slice(0, 30)
              .replace(/(.{27}).{3,}/, '$1...')}
          </span>
          <span>?</span>


        </div>
        <div className="flex justify-end gap-2">
          <button
            onClick={() => setIsOpenDeleteFileModal(false)}
            className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
          >
            No
          </button>
          <button
            onClick={() => {
              props.onDelete(props.index);
              setIsOpenDeleteFileModal(false)
              setIsSaveConfigBlink(true);
              setTimeout(() => {
                setIsSaveConfigBlink(false);
              }, 1000);
            }}
            className="px-4 py-2 rounded bg-red-500 text-white hover:bg-red-600"
          >
            Yes
          </button>
        </div>
      </AntModal>

      <div className="grid grid-cols-12    w-full relative">


        <div
          className={`     flex items-center justify-center  col-span-2`}
        >
          {props.values.length !== 1 ? (
            <div
              className="flex mx-1  flex-col justify-between gap-y-3 w-[50px] items-center col-span-1 py-2 rounded-lg "
            >
              {props?.index != 0 && (
                <Button
                  className="border border-gray-300 rounded p-2 w-8 h-8  transition-all"
                  variant="outline"
                  onClick={() => moveLineItemToXindex(props?.index, -1)}
                >
                  <ArrowUp additionalClasses="w-4 h-4" />
                </Button>
              )}
              {props?.index != createQuoteState?.values?.length - 1 && (
                <Button
                  className="border border-gray-300 rounded p-2 w-8 h-8  transition-all"
                  variant="outline"
                  onClick={() => moveLineItemToXindex(props?.index, 1)}
                >
                  <ArrowDown additionalClasses="w-4 h-4" />
                </Button>
              )}
            </div>

          ) : null}
          <ThreeDViewerComponent
            item={props.singleValue}
            selectedProcess={commanValues?.selectedProcess}
            snapShotClassName={!isAnyProcessEditingActivated ? ' h-16 !object-contain  ' : ''}
          />
        </div>
        <div className="text-col col-span-10    p-2  h-full ">
          <div className={`${!isAnyProcessEditingActivated ? 'flex text-xs relative  justify-between lg:flex-row  flex-col items-start lg:items-start -mb-2' : 'flex justify-between gap-x-2'} `}>

            <div className={` ${!isAnyProcessEditingActivated ? 'flex flex-col    !w-[300px] 2xl:w-1/5  ' : 'flex flex-col   col-span-8'}   `}>
              {props.singleValue?.selectedFile ? <Tooltip
                placement="bottom" // Tooltip appears below the select
                overlayInnerStyle={{
                  fontSize: "10px",
                  padding: "2px 6px",  // Reduce padding to make it smaller
                  lineHeight: "12px", // Adjust line height to center text
                  minHeight: "20px",  // Ensures tooltip height is minimal
                  display: "flex",
                  alignItems: "center", // Center the text vertically
                }}
                title={(props.singleValue?.selectedFile?.originalname || props.singleValue?.selectedFile?.name || props.singleValue?.linePartName || "SamplePart.stp")}
                mouseEnterDelay={0}
                mouseLeaveDelay={0} // Instant hide
              >
                <h6
                  onClick={
                    showDownload
                      ? () => handleThreeDFileDownloading(props.singleValue?.selectedFile)
                      : undefined
                  }
                  className="text !text-primaryColor font-bold flex gap-x-2 mb-1"
                >
                  <FileName
                    name={
                      props.singleValue?.selectedFile?.originalname
                      || props.singleValue?.selectedFile?.name
                      || props.singleValue?.linePartName
                      || "SamplePart.stp"
                    }
                    showFullName={isEditingActivatedThreeD || isEditingActivatedCnc}
                  />
                  {showDownload && (
                    !isThreeDFileDownloading
                      ? <span><DownloadIcon /></span>
                      : <LucidLoader />
                  )}
                </h6>
                <p>
                  <div className="text-red-500 flex items-center gap-1 text-xs">
                    {!isGlobalLoading &&
                      quoteId && !isAnyProcessEditingActivated &&
                      !isValidFileForPricing(props.singleValue?.selectedFile?.originalname) && (
                        <>
                          {allInstanceData._8xPart === name && (
                            <p className="flex flex-col  justify-center gap-x-1 py-1 w-full rounded">
                              <div className="flex items-center justify-start gap-x-1 py-1 w-full rounded">
                                <WarningIcon additionalClasses="h-3 w-3 mr-1" />
                                <span className="font-medium">Unsupported file format (RFQ)</span>
                              </div>
                              <a
                                href="https://knowledge.8xparts.com/en/articles/10486000-why-our-application-supports-only-step-and-stp-file-formats"
                                target="_blank"
                                className="underline text-blue-500 hover:text-blue-600 ml-1"
                              >
                                Read More
                              </a>
                            </p>
                          )}

                          {allInstanceData.NDCS === name && (
                            <p className="flex flex-col  justify-center gap-x-1 py-1 w-full rounded">
                              <div className="flex items-center justify-start gap-x-1 py-1 w-full rounded">
                                <WarningIcon additionalClasses="h-3 w-3 mr-1" />
                                <span className="font-medium">Unsupported file format (RFQ)</span>
                              </div>
                              <a href="/knowledge" target="_blank" className="underline text-blue-500 hover:text-blue-600 ml-1">
                                Read More
                              </a>
                            </p>
                          )}
                        </>
                      )}
                  </div>
                </p>
              </Tooltip> :
                <>
                  {!isThreeDFileUploading ? <div className="file-button !cursor-pointer relative">
                    <input
                      name="file-input-3d"
                      id={`file-input-3d-${props.index}`}
                      className={`file-input__input `}
                      type="file"
                      onChange={handleThreeDFileUploading}
                      // disabled={isGlobalLoading}
                      accept=".stp,.step"
                    />
                    <label
                      className={`icon-btn cursor-pointer ${isGlobalLoading ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                      htmlFor={`file-input-3d-${props.index}`}

                    >
                      <span
                        className={`flex  items-center p-1 rounded text-xs link-btn edit-btn border-btn p-2 ${props.singleValue?.twoDFileRequired ? "bg-red-400 text-white" : "bg-white text-black"
                          }`}
                      >
                        <UploadIcon
                          additionalClass={`h-4 w-4 ${props.singleValue?.twoDFileRequired ? "text-white" : "text-black"
                            }`}
                        />
                        <span className={props.singleValue?.twoDFileRequired ? "text-white" : "text-black"}>
                          3D Model
                        </span>
                        {props.singleValue?.twoDFileRequired && (
                          <span className="text-white ml-2">(required)</span>
                        )}
                      </span>
                    </label>
                  </div> :
                    <div className="icon-btn upload-btn-loading">
                      <LucidLoader additionalClass={'h-4'} />
                    </div>}
                </>}

              {isValidFileName(props.singleValue?.selectedFile?.originalname || props.singleValue?.selectedFile?.name) &&
                props.singleValue?.stagingPartsDataId &&
                (props.singleValue.stagingPartsDataId.bboxDx_mm ||
                  props.singleValue.stagingPartsDataId.bboxDy_mm ||
                  props.singleValue.stagingPartsDataId.bboxDz_mm) ? (
                <>
                  <p className="info-text">
                    {(!props.isInchSelected ? props?.singleValue?.stagingPartsDataId?.bboxDx_mm : props?.singleValue?.stagingPartsDataId?.bboxDx_in)} X
                    {(!props.isInchSelected ? props?.singleValue?.stagingPartsDataId?.bboxDy_mm : props?.singleValue?.stagingPartsDataId?.bboxDy_in)} X
                    {(!props.isInchSelected ? props?.singleValue?.stagingPartsDataId?.bboxDz_mm : props?.singleValue?.stagingPartsDataId?.bboxDz_in)}
                    {props.isInchSelected ? " (inch)" : " (mm)"}
                    {"   "}/{"   "}
                    {props?.singleValue?.stagingPartsDataId?.totalVolume_mm3 && (
                      <>
                        {
                          props.isInchSelected
                            ? roundToTwoDigits(props?.singleValue?.stagingPartsDataId?.totalVolume_mm3 / miliMeterToInchFactor)
                            : props?.singleValue?.stagingPartsDataId?.totalVolume_mm3
                        }{" "}
                        {props.isInchSelected ? " (in³)" : " (mm³)"}
                      </>
                    )}
                  </p>
                </>
              ) : (
                <>
                </>)}
              <div>
                {(props?.singleValue?.twoDFile?.originalname || props?.singleValue?.twoDFile?.name) ? (
                  <>
                    <div className="upload-2d-file-div">
                      <a
                        onClick={async () => {
                          const { originalname } = props?.singleValue?.twoDFile;
                          if (originalname && originalname.endsWith('.pdf')) {
                            const signedUrl = await getPresignedUrlForFile(props?.singleValue?.twoDFile.bucket, props?.singleValue?.twoDFile.key);
                            console.log('Signed URL for PDF:', signedUrl);
                            setPdfModalInfo({
                              show: true,
                              pdfUrl: signedUrl,
                              fileName: originalname,
                            })
                            return;

                          }
                          downloadFileFromS3(props?.singleValue?.twoDFile)
                        }}
                      >
                        <span className="text-sm !text-primaryColor">
                          <FileName
                            name={props?.singleValue?.twoDFile?.originalname || props?.singleValue?.twoDFile?.name || ""}
                            showFullName={false}
                          />
                        </span>{" "}
                        <DownloadIcon additionalClass={'h-4 text-primaryColor'} />
                      </a>
                      {/* &nbsp;&nbsp;&nbsp; */}
                      <div className="" onClick={handleDelete2DFiles}>
                        <DeleteIcon
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    {!isTwoDFileUploading ? <div className="file-button !cursor-pointer relative">
                      <input
                        name="file-input-2d"
                        id={`file-input-2d-${props.index}`}
                        className={`file-input__input `}
                        type="file"
                        onChange={handle2DFileUpload}
                      // disabled={isGlobalLoading}
                      />
                      <label
                        className={`icon-btn cursor-pointer ${isGlobalLoading ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                        htmlFor={`file-input-2d-${props.index}`}

                      >
                        <span
                          className={`flex  items-center p-1 rounded text-xs link-btn edit-btn border-btn p-2 ${props.singleValue?.twoDFileRequired ? "bg-red-400 text-white" : "bg-white text-black"
                            }`}
                        >
                          <UploadIcon
                            additionalClass={`h-4 w-4 ${props.singleValue?.twoDFileRequired ? "text-white" : "text-black"
                              }`}
                          />
                          <span className={props.singleValue?.twoDFileRequired ? "text-white" : "text-black"}>
                            Technical Drawing
                          </span>
                          {props.singleValue?.twoDFileRequired && (
                            <span className="text-white ml-2">(required)</span>
                          )}
                        </span>
                      </label>
                    </div> :
                      <div className="icon-btn upload-btn-loading">
                        <LucidLoader additionalClass={'h-4'} />
                      </div>}
                  </>
                )}
              </div>
            </div>

            {/* config details */}
            {(
              selectedMaterialName && selectedGradeName
            ) || (
                threeDTechnologyName && threeDMaterialName && threeDPostProcessName
              ) ? <div
                className={`config-details-col  !mx-3  w-3/5 2xl:w-4/5   grid grid-cols-${commanValues?.selectedProcess === 1 ? '4' : '3'}  md:gap-1       `}
                style={
                  (isEditingActivatedCnc || isEditingActivatedThreeD) ? { display: "none" } : { display: "grid" }
                }
              >
              {
                commanValues?.selectedProcess === 1 ?
                  <>

                    {selectedMaterialName ?
                      <Tooltip
                        placement="bottom" // Tooltip appears below the select
                        overlayInnerStyle={{
                          fontSize: "10px",
                          padding: "2px 6px",  // Reduce padding to make it smaller
                          lineHeight: "12px", // Adjust line height to center text
                          minHeight: "20px",  // Ensures tooltip height is minimal
                          display: "flex",
                          alignItems: "center", // Center the text vertically
                        }}
                        title={
                          'Click on Edit Configuration to modify specification'
                        }
                        arrow={false}
                        mouseEnterDelay={0}
                        mouseLeaveDelay={0} // Instant hide
                      >


                        <div className="config-item">
                          <p className="name info-text">Material</p>
                          <p className="config text">
                            {selectedMaterialName}
                          </p>
                        </div>
                      </Tooltip> : null}
                    {selectedGradeName ?

                      <Tooltip
                        placement="bottom" // Tooltip appears below the select
                        overlayInnerStyle={{
                          fontSize: "10px",
                          padding: "2px 6px",  // Reduce padding to make it smaller
                          lineHeight: "12px", // Adjust line height to center text
                          minHeight: "20px",  // Ensures tooltip height is minimal
                          display: "flex",
                          alignItems: "center", // Center the text vertically
                        }}
                        title={
                          'Click on Edit Configuration to modify specification'
                        }
                        arrow={false}
                        mouseEnterDelay={0}
                        mouseLeaveDelay={0} // Instant hide
                      >
                        <div className="config-item">
                          <p className="name info-text">Grade</p>
                          <p className="config text">{selectedGradeName}</p>
                        </div>
                      </Tooltip>

                      : null}
                    {surfaceFinishName && selectedMaterialName ?
                      <Tooltip
                        placement="bottom" // Tooltip appears below the select
                        overlayInnerStyle={{
                          fontSize: "10px",
                          padding: "2px 6px",  // Reduce padding to make it smaller
                          lineHeight: "12px", // Adjust line height to center text
                          minHeight: "20px",  // Ensures tooltip height is minimal
                          display: "flex",
                          alignItems: "center", // Center the text vertically
                        }}
                        title={
                          'Click on Edit Configuration to modify specification'
                        }
                        arrow={false}
                        mouseEnterDelay={0}
                        mouseLeaveDelay={0} // Instant hide
                      >
                        <div className="config-item">
                          <p className="name info-text">Surface Finish</p>
                          <p className="config text">
                            {
                              surfaceFinishName
                            }
                          </p>
                        </div>
                      </Tooltip>

                      : null}
                    {headTreatmentName && selectedMaterialName ?
                      <Tooltip
                        placement="bottom" // Tooltip appears below the select
                        overlayInnerStyle={{
                          fontSize: "10px",
                          padding: "2px 6px",  // Reduce padding to make it smaller
                          lineHeight: "12px", // Adjust line height to center text
                          minHeight: "20px",  // Ensures tooltip height is minimal
                          display: "flex",
                          alignItems: "center", // Center the text vertically
                        }}
                        title={
                          'Click on Edit Configuration to modify specification'
                        }
                        arrow={false}
                        mouseEnterDelay={0}
                        mouseLeaveDelay={0} // Instant hide
                      >
                        <div className="config-item">
                          <p className="name info-text">Heat Treatment</p>
                          <p className="config text">
                            {
                              headTreatmentName
                            }
                          </p>
                        </div>
                      </Tooltip>
                      : null}
                    {toleranceName && selectedMaterialName ?
                      <Tooltip
                        placement="bottom" // Tooltip appears below the select
                        overlayInnerStyle={{
                          fontSize: "10px",
                          padding: "2px 6px",  // Reduce padding to make it smaller
                          lineHeight: "12px", // Adjust line height to center text
                          minHeight: "20px",  // Ensures tooltip height is minimal
                          display: "flex",
                          alignItems: "center", // Center the text vertically
                        }}
                        title={
                          'Click on Edit Configuration to modify specification'
                        }
                        arrow={false}
                        mouseEnterDelay={0}
                        mouseLeaveDelay={0} // Instant hide
                      >
                        <div className="config-item">
                          <p className="name info-text">Tolerance</p>
                          <p className="config text">
                            {
                              toleranceName
                            }
                          </p>
                        </div>
                      </Tooltip>
                      : null}
                    {props.singleValue?.cncInternalCorner && selectedMaterialName ?
                      <Tooltip
                        placement="bottom" // Tooltip appears below the select
                        overlayInnerStyle={{
                          fontSize: "10px",
                          padding: "2px 6px",  // Reduce padding to make it smaller
                          lineHeight: "12px", // Adjust line height to center text
                          minHeight: "20px",  // Ensures tooltip height is minimal
                          display: "flex",
                          alignItems: "center", // Center the text vertically
                        }}
                        title={
                          'Click on Edit Configuration to modify specification'
                        }
                        arrow={false}
                        mouseEnterDelay={0}
                        mouseLeaveDelay={0} // Instant hide
                      >
                        <div className="config-item">
                          <p className="name info-text">Internal Corner</p>
                          <p className="config text">
                            {
                              internalCornerName}
                          </p>
                        </div>
                      </Tooltip>
                      : null}
                    {reviewMyDesignName && selectedMaterialName ?
                      <Tooltip
                        placement="bottom" // Tooltip appears below the select
                        overlayInnerStyle={{
                          fontSize: "10px",
                          padding: "2px 6px",  // Reduce padding to make it smaller
                          lineHeight: "12px", // Adjust line height to center text
                          minHeight: "20px",  // Ensures tooltip height is minimal
                          display: "flex",
                          alignItems: "center", // Center the text vertically
                        }}
                        title={
                          'Click on Edit Configuration to modify specification'
                        }
                        arrow={false}
                        mouseEnterDelay={0}
                        mouseLeaveDelay={0} // Instant hide
                      >
                        <div className="config-item">
                          <p className="name info-text">Review My Design</p>
                          <p className="config text">
                            {
                              reviewMyDesignName}
                          </p>
                        </div>
                      </Tooltip>
                      : null}
                    {partMarkingName && selectedMaterialName ?
                      <Tooltip
                        placement="bottom" // Tooltip appears below the select
                        overlayInnerStyle={{
                          fontSize: "10px",
                          padding: "2px 6px",  // Reduce padding to make it smaller
                          lineHeight: "12px", // Adjust line height to center text
                          minHeight: "20px",  // Ensures tooltip height is minimal
                          display: "flex",
                          alignItems: "center", // Center the text vertically
                        }}
                        title={
                          'Click on Edit Configuration to modify specification'
                        }
                        arrow={false}
                        mouseEnterDelay={0}
                        mouseLeaveDelay={0} // Instant hide
                      >
                        <div className="config-item">
                          <p className="name info-text">Part Marking</p>
                          <p className="config text">
                            {
                              partMarkingName
                            }
                          </p>
                        </div>
                      </Tooltip>
                      : null}
                    {props.singleValue.description && selectedMaterialName ?
                      <Tooltip
                        placement="bottom" // Tooltip appears below the select
                        overlayInnerStyle={{
                          fontSize: "10px",
                          padding: "2px 6px",  // Reduce padding to make it smaller
                          lineHeight: "12px", // Adjust line height to center text
                          minHeight: "20px",  // Ensures tooltip height is minimal
                          display: "flex",
                          alignItems: "center", // Center the text vertically
                        }}
                        title={
                          'Click on Edit Configuration to modify specification'
                        }
                        arrow={false}
                        mouseEnterDelay={0}
                        mouseLeaveDelay={0} // Instant hide
                      >
                        <div className="config-item">
                          <p className="name info-text">Description</p>
                          <p className="config text">{props.singleValue.description}</p>
                        </div>
                      </Tooltip>
                      : null}
                  </> :
                  <>
                    <Tooltip
                      placement="bottom" // Tooltip appears below the select
                      overlayInnerStyle={{
                        fontSize: "10px",
                        padding: "2px 6px",  // Reduce padding to make it smaller
                        lineHeight: "12px", // Adjust line height to center text
                        minHeight: "20px",  // Ensures tooltip height is minimal
                        display: "flex",
                        alignItems: "center", // Center the text vertically
                      }}
                      title={
                        'Click on Edit Configuration to modify specification'
                      }
                      arrow={false}
                      mouseEnterDelay={0}
                      mouseLeaveDelay={0} // Instant hide
                    >
                      <div className="config-item">
                        <p className="name info-text">Technology/Process</p>
                        <p className="config text">
                          {
                            threeDTechnologyName
                          }
                        </p>
                      </div>
                    </Tooltip>

                    <Tooltip
                      placement="bottom" // Tooltip appears below the select
                      overlayInnerStyle={{
                        fontSize: "10px",
                        padding: "2px 6px",  // Reduce padding to make it smaller
                        lineHeight: "12px", // Adjust line height to center text
                        minHeight: "20px",  // Ensures tooltip height is minimal
                        display: "flex",
                        alignItems: "center", // Center the text vertically
                      }}
                      title={
                        'Click on Edit Configuration to modify specification'
                      }
                      arrow={false}
                      mouseEnterDelay={0}
                      mouseLeaveDelay={0} // Instant hide
                    >
                      <div className="config-item">
                        <p className="name info-text">Material</p>
                        <p className="config text">
                          {
                            threeDMaterialName
                          }
                        </p>
                      </div>
                    </Tooltip>

                    <Tooltip
                      placement="bottom" // Tooltip appears below the select
                      overlayInnerStyle={{
                        fontSize: "10px",
                        padding: "2px 6px",  // Reduce padding to make it smaller
                        lineHeight: "12px", // Adjust line height to center text
                        minHeight: "20px",  // Ensures tooltip height is minimal
                        display: "flex",
                        alignItems: "center", // Center the text vertically
                      }}
                      title={
                        'Click on Edit Configuration to modify specification'
                      }
                      arrow={false}
                      mouseEnterDelay={0}
                      mouseLeaveDelay={0} // Instant hide
                    >
                      <div className="config-item">
                        <p className="name info-text">Surface Finish</p>
                        <p className="config text">
                          {
                            threeDPostProcessName
                          }
                        </p>
                      </div>
                    </Tooltip>

                  </>
              }
            </div> : !isAnyProcessEditingActivated ? <LucidLoader additionalClass={'text-primaryColor'} /> : null}
            <div style={{
              display: !isAnyProcessEditingActivated ? "none" : "block"
            }} className={'flex !justify-between    col-span-3 '}>
              <div className="">
                {
                  !isGlobalLoading ? <div className="flex w-20  ">
                    {!(
                      (!props?.singleValue?.price1 &&
                        !props?.singleValue?.price2 &&
                        !props?.singleValue?.price3
                      ) ||
                      (props?.singleValue[keyFirst] &&
                        !props?.singleValue[keyFirst][keySecond])
                    ) ? <div className="w-max ">
                      {
                        (props?.commanValues?.selectedShipMethod === 1 && !props?.commanValues?.isQuoteChanged && props?.singleValue?.price1 && props?.singleValue[keyFirst] && props?.singleValue[keyFirst][keySecond]) ? (
                          <div className="flex flex-col font-medium">
                            <div>{currencyFormatter(props?.singleValue?.price1 * props?.singleValue?.Qty)}</div>
                            <div>{currencyFormatter(props?.singleValue?.price1)} <span className="text-slate-500">Each</span></div>
                          </div>
                        ) : (props?.commanValues?.selectedShipMethod === 2 && !props?.commanValues?.isQuoteChanged && props?.singleValue?.price2 && props?.singleValue[keyFirst] && props?.singleValue[keyFirst][keySecond]) ? (
                          <div>
                            <div className="flex flex-col font-medium ">
                              <div>{currencyFormatter(props?.singleValue?.price2 * props?.singleValue?.Qty)}</div>
                              <div>{currencyFormatter(props?.singleValue?.price2)} <span className="text-slate-500">Each</span></div>
                            </div>
                          </div>
                        ) : (props?.commanValues?.selectedShipMethod === 3 && !props?.commanValues?.isQuoteChanged && props?.singleValue?.price3 && props?.singleValue[keyFirst] && props?.singleValue[keyFirst][keySecond]) ? (
                          <div>
                            <div className="flex flex-col font-medium ">
                              <div>{currencyFormatter(props?.singleValue?.price3 * props?.singleValue?.Qty)}</div>
                              <div>{currencyFormatter(props?.singleValue?.price3)} <span className="text-slate-500">Each</span></div>
                            </div>
                          </div>
                        ) : isGlobalLoading ?
                          null
                          : null
                      }
                    </div> : <p className={` text-[12px] whitespace-nowrap `}>
                      <span className="text-red-500">Review Required</span>
                      {!props?.commanValues?.isQuoteChanged &&
                        ((props?.commanValues?.selectedShipMethod === 1 && props?.singleValue?.price1) ||
                          (props?.commanValues?.selectedShipMethod === 2 && props?.singleValue?.price2) ||
                          (props?.commanValues?.selectedShipMethod === 3 && props?.singleValue?.price3)) ? (
                        <div className="text-sm">
                          {
                            props?.commanValues?.selectedShipMethod === 1 && props?.singleValue?.price1 ? (
                              <div className="flex flex-col font-medium">
                                <div>{currencyFormatter(props?.singleValue?.price1 * props?.singleValue?.Qty)}</div>
                                <div>{currencyFormatter(props?.singleValue?.price1)} <span className="text-slate-500">Each</span></div>
                              </div>
                            ) : props?.commanValues?.selectedShipMethod === 2 && props?.singleValue?.price2 ? (
                              <div className="flex flex-col font-medium ">
                                <div>{currencyFormatter(props?.singleValue?.price2 * props?.singleValue?.Qty)}</div>
                                <div>{currencyFormatter(props?.singleValue?.price2)} <span className="text-slate-500">Each</span></div>
                              </div>
                            ) : props?.commanValues?.selectedShipMethod === 3 && props?.singleValue?.price3 ? (
                              <div className="flex flex-col font-medium ">
                                <div>{currencyFormatter(props?.singleValue?.price3 * props?.singleValue?.Qty)}</div>
                                <div>{currencyFormatter(props?.singleValue?.price3)} <span className="text-slate-500">Each</span></div>
                              </div>
                            ) : null
                          }
                          <p className="!text-[12px] text-red-500 ">(Estimated part cost)</p>

                        </div>
                      ) : null}
                    </p>}
                  </div> :
                    <div >
                      <SmallGlobalLoader
                        height={70}
                      />
                    </div>
                }
              </div>
              <div className="flex  items-center  ">
                <label style={{ fontSize: 13 }}>Quantity : </label>
                <div class="relative flex  max-w-[8rem]">
                  <Tooltip
                    placement="bottom"
                    overlayInnerStyle={{
                      fontSize: "10px",
                      padding: "2px 6px",
                      lineHeight: "12px",
                      minHeight: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                    title={
                      props.selectedProcess === 1 && !props.isEditingActivatedCnc
                        ? 'Click on Edit Configuration to modify specification'
                        : props.selectedProcess === 2 && !props.isEditingActivatedThreeD
                          ? 'Click on Edit Configuration to modify specification'
                          : ""
                    }
                    mouseEnterDelay={0}
                    mouseLeaveDelay={0}
                  >
                    <span className="w-full">
                      {isAnyProcessEditingActivated ? <Form.Control
                        type="text"
                        onWheel={numberInputOnWheelPreventChange}
                        size="sm"
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                        }
                        onChange={(e) => {
                          handleQtyChange(e.target.value);
                        }}
                        value={props.singleValue.Qty}
                        className={`quantity-input ${!props.singleValue.Qty || props.singleValue.Qty <= 0
                          ? "!border !border-red-500"
                          : ""
                          } ${(() => {
                            if (props.selectedProcess === 1 && !props.isEditingActivatedCnc) {
                              return "cursor-not-allowed";
                            }
                            if (props.selectedProcess === 2 && !props.isEditingActivatedThreeD) {
                              return "cursor-not-allowed";
                            }
                            return "";
                          })()
                          }`}
                        disabled={
                          (() => {
                            if (props.selectedProcess === 1) {
                              return !props.isEditingActivatedCnc || isGlobalLoading;
                            }
                            if (props?.selectedProcess === 2) {
                              return !props.isEditingActivatedThreeD || isGlobalLoading;
                            }
                          })()
                        }
                      /> : <p className="text-[14px]">{props.singleValue.Qty}</p>}
                    </span>
                  </Tooltip>
                </div>
              </div>
              {!isGlobalLoading ? <button
                onClick={() => {
                  setIsOpenDeleteFileModal(true);

                }}
                className="px-2 py-1 mt-2 bg-red-500 text-white text-xs rounded-md flex items-center gap-1 hover:bg-red-600 transition duration-200"
              >
                <span className="ms-2">  Delete</span>
                <span>  <DeleteIcon additionalClasses={'text-white !h-3'} /></span>
              </button> : null}
            </div>
          </div>
          <div
            className="form-box w-full mx-2"
            style={
              (isEditingActivatedCnc || isEditingActivatedThreeD) ? { display: "block" } : { display: "none" }
            }
          >
            <div className="mb-1 flex items-center gap-x-2 justify-between item-center">
              <div className="text-red-500 flex items-center gap-1 text-xs">
                {!isGlobalLoading &&
                  quoteId &&
                  !isValidFileForPricing(props.singleValue?.selectedFile?.originalname) && (
                    <>
                      {allInstanceData._8xPart === name && (
                        <p className="flex items-center justify-start gap-x-1 py-1 w-full rounded">
                          <WarningIcon additionalClasses="h-3 w-3 mr-1" />
                          <span className="font-medium">Unsupported file format (RFQ)</span>
                          <a
                            href="https://knowledge.8xparts.com/en/articles/10486000-why-our-application-supports-only-step-and-stp-file-formats"
                            target="_blank"
                            className="underline text-blue-500 hover:text-blue-600 ml-1"
                          >
                            Read More
                          </a>
                        </p>
                      )}

                      {allInstanceData.NDCS === name && (
                        <p className="flex items-center justify-start gap-x-1 py-1 w-full rounded">
                          <WarningIcon additionalClasses="h-3 w-3 mr-1" />
                          <span className="font-medium">Unsupported file format (RFQ)</span>
                          <a href="/knowledge" target="_blank" className="underline text-blue-500 hover:text-blue-600 ml-1">
                            Read More
                          </a>
                        </p>
                      )}
                    </>
                  )}
              </div>


            </div>
            <Row className="form-box-row w-full">
              <Col>
                <div className="form-left   w-full">
                  <Form >
                    {props.selectedProcess === 1 ? (
                      <Row>
                        <Col md={4}>
                          <Form.Group
                            className="mb-0"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className={"frm-label"}>
                              Materials
                            </Form.Label>
                            <Tooltip
                              placement="bottom" // Tooltip appears below the select
                              overlayInnerStyle={{
                                fontSize: "10px",
                                padding: "2px 6px",  // Reduce padding to make it smaller
                                lineHeight: "12px", // Adjust line height to center text
                                minHeight: "20px",  // Ensures tooltip height is minimal
                                display: "flex",
                                alignItems: "center", // Center the text vertically
                              }}
                              title={
                                props.selectedProcess === 1 && !props.isEditingActivatedCnc
                                  ? 'Click "Edit configuration" to modify'
                                  : props.selectedProcess === 2 && !props.isEditingActivatedThreeD
                                    ? 'Click "Edit configuration" to modify'
                                    : ""
                              }
                              mouseEnterDelay={0}
                              mouseLeaveDelay={0} // Instant hide
                            >
                              <Select
                                showSearch
                                optionFilterProp="value"
                                onChange={(e) => {
                                  const value = e;
                                  handleOptionChange(16, value);
                                  setSelectedMaterialName(value);
                                  setIsCncMaterialChangedByDropDown(true);
                                }}
                                className={`text-xs -mt-1 w-full ${props?.singleValue?.errors?.MaterialType &&
                                  isValidFileName(props?.singleValue?.selectedFile?.originalname)
                                  ? "error-bg"
                                  : ""
                                  }`}
                                value={selectedMaterialName}
                                disabled={!props.isEditingActivatedCnc || isGlobalLoading}
                                required={true}
                                title=""
                              >
                                {materialGradeData &&
                                  Object.keys(materialGradeData)?.map((singleMaterial, m) => {
                                    return (
                                      <Select.Option value={singleMaterial} key={`m-${m}`}>
                                        {singleMaterial}
                                      </Select.Option>
                                    );
                                  })}
                              </Select>
                            </Tooltip>
                          </Form.Group>

                          {props?.singleValue?.errors?.cncMaterial &&
                            !props.isInvalidFiles && (
                              <span className="error">
                                Please select Material Type
                              </span>
                            )}
                        </Col>
                        <Col md={4}>
                          <Form.Group
                            className="mb-0"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label className={"frm-label"}>
                              Grade
                            </Form.Label>
                            <Tooltip
                              placement="bottom" // Tooltip appears below the select
                              overlayInnerStyle={{
                                fontSize: "10px",
                                padding: "2px 6px",  // Reduce padding to make it smaller
                                lineHeight: "12px", // Adjust line height to center text
                                minHeight: "20px",  // Ensures tooltip height is minimal
                                display: "flex",
                                alignItems: "center", // Center the text vertically
                              }}
                              title={
                                props.selectedProcess === 1 && !props.isEditingActivatedCnc
                                  ? 'Click "Edit configuration" to modify'
                                  : props.selectedProcess === 2 && !props.isEditingActivatedThreeD
                                    ? 'Click "Edit configuration" to modify'
                                    : ""
                              }
                              mouseEnterDelay={0}
                              mouseLeaveDelay={0} // Instant hide
                            >
                              <Select
                                showSearch
                                optionFilterProp="value"
                                onChange={(e) => {
                                  const value = e;
                                  setSelectedGradeName(value);
                                  setIsCncMaterialChangedByDropDown(true);
                                }}
                                className={`text-xs -mt-1 w-full ${props?.singleValue?.errors?.SubMaterial &&
                                  isValidFileName(props?.singleValue?.selectedFile?.originalname)
                                  ? "error-bg"
                                  : ""
                                  }`}
                                value={selectedGradeName}
                                disabled={!props.isEditingActivatedCnc || isGlobalLoading}
                                title=""
                              >
                                {materialGradeData && Array.isArray(materialGradeData[selectedMaterialName]) && materialGradeData[selectedMaterialName].map((singleSubMaterial, index) => {
                                  return (
                                    <Select.Option
                                      value={singleSubMaterial}
                                      key={`f-${index}`}
                                    >
                                      {singleSubMaterial}
                                    </Select.Option>
                                  );
                                })}
                              </Select>
                            </Tooltip>
                          </Form.Group>

                          {props?.singleValue?.errors?.SubMaterial &&
                            !props.isInvalidFiles && (
                              <span className="error">
                                Please select Sub Material Type
                              </span>
                            )}
                        </Col>

                        {props.selectedProcess === 1 && surfaceFinish.length != 0 && (
                          <Col md={4}>
                            <Form.Group
                              className="mb-0"
                              controlId="exampleForm.ControlTextarea1"
                            >
                              <Form.Label className="frm-label">
                                Surface Finish
                              </Form.Label>
                              <Tooltip
                                placement="bottom" // Tooltip appears below the select
                                overlayInnerStyle={{
                                  fontSize: "10px",
                                  padding: "2px 6px",  // Reduce padding to make it smaller
                                  lineHeight: "12px", // Adjust line height to center text
                                  minHeight: "20px",  // Ensures tooltip height is minimal
                                  display: "flex",
                                  alignItems: "center", // Center the text vertically
                                }}
                                title={
                                  props.selectedProcess === 1 && !props.isEditingActivatedCnc
                                    ? 'Click "Edit configuration" to modify'
                                    : props.selectedProcess === 2 && !props.isEditingActivatedThreeD
                                      ? 'Click "Edit configuration" to modify'
                                      : ""
                                }
                                mouseEnterDelay={0}
                                mouseLeaveDelay={0} // Instant hide
                              >
                                <Select
                                  showSearch
                                  optionFilterProp="value"
                                  className="text-xs -mt-1 w-full"
                                  aria-label="Default select example"
                                  onChange={(e) => {
                                    handleOptionChange(3, e);
                                  }}
                                  value={props.singleValue?.cncSurfaceFinish}
                                  disabled={!props.isEditingActivatedCnc || isGlobalLoading}
                                  title=""
                                >
                                  <option value="">Select Values</option>
                                  {surfaceFinish?.length > 0 &&
                                    surfaceFinish.map((Item, s) => {
                                      return (
                                        <Select.Option value={Item._id} key={`s-${s}`}>
                                          {Item.cnc_surface_finish}
                                        </Select.Option>
                                      );
                                    })}
                                </Select>
                              </Tooltip>
                            </Form.Group>
                          </Col>
                        )}
                        {heatTreatment.length != 0 ? <Col md={4}>
                          <Form.Group
                            className="mb-0"
                            controlId="exampleForm.ControlTextarea1"
                          >
                            <Form.Label className="frm-label">
                              Heat Treatment
                            </Form.Label>
                            <Tooltip
                              placement="bottom" // Tooltip appears below the select
                              overlayInnerStyle={{
                                fontSize: "10px",
                                padding: "2px 6px",  // Reduce padding to make it smaller
                                lineHeight: "12px", // Adjust line height to center text
                                minHeight: "20px",  // Ensures tooltip height is minimal
                                display: "flex",
                                alignItems: "center", // Center the text vertically
                              }}
                              title={
                                props.selectedProcess === 1 && !props.isEditingActivatedCnc
                                  ? 'Click "Edit configuration" to modify'
                                  : props.selectedProcess === 2 && !props.isEditingActivatedThreeD
                                    ? 'Click "Edit configuration" to modify'
                                    : ""
                              }
                              mouseEnterDelay={0}
                              mouseLeaveDelay={0} // Instant hide
                            >
                              <Select
                                showSearch
                                optionFilterProp="children"
                                aria-label="Default select example"
                                className="text-xs -mt-1 w-full"
                                onChange={(e) => {
                                  handleOptionChange(4, e);
                                }}
                                value={isCncDropDownLoading ? undefined : props.singleValue?.cncHeatTreatment}
                                placeholder={isCncDropDownLoading ? "Loading..." : "Select Values"}
                                disabled={isCncDropDownLoading || !props.isEditingActivatedCnc || isGlobalLoading}
                                title=""
                              >
                                { // Only render options when loading is complete
                                  heatTreatment?.map((singleTreatment, index) => (
                                    <Select.Option
                                      value={singleTreatment._id}
                                      key={`f-${index}`}
                                    >
                                      {singleTreatment.cnc_heat_treatment}
                                    </Select.Option>
                                  ))}
                              </Select>
                            </Tooltip>
                          </Form.Group>
                        </Col> : null}

                        {props.selectedProcess === 1 && allToleranceData.length != 0 && (
                          <Col md={4}>
                            <Form.Group
                              className="mb-0"
                              controlId="exampleForm.ControlTextarea1"
                            >
                              <Form.Label className="frm-label">Tolerance</Form.Label>
                              <Tooltip
                                placement="bottom" // Tooltip appears below the select
                                overlayInnerStyle={{
                                  fontSize: "10px",
                                  padding: "2px 6px",  // Reduce padding to make it smaller
                                  lineHeight: "12px", // Adjust line height to center text
                                  minHeight: "20px",  // Ensures tooltip height is minimal
                                  display: "flex",
                                  alignItems: "center", // Center the text vertically
                                }}
                                title={
                                  props.selectedProcess === 1 && !props.isEditingActivatedCnc
                                    ? 'Click "Edit configuration" to modify'
                                    : props.selectedProcess === 2 && !props.isEditingActivatedThreeD
                                      ? 'Click "Edit configuration" to modify'
                                      : ""
                                }
                                mouseEnterDelay={0}
                                mouseLeaveDelay={0} // Instant hide
                              >
                                <Select
                                  showSearch
                                  optionFilterProp="value"
                                  aria-label="Default select example"
                                  onChange={(e) => {
                                    handleOptionChange(5, e);
                                  }}
                                  value={props.singleValue?.cncTolerance}
                                  className="text-xs -mt-1 w-full"
                                  disabled={!props.isEditingActivatedCnc || isGlobalLoading}
                                  title=""
                                >
                                  <option value="">Select Values</option>
                                  {allToleranceData.length > 0 &&
                                    allToleranceData.map((Item, t) => {
                                      return (
                                        <Select.Option value={Item._id} key={`f-${t}`}>
                                          {Item.cnc_tolerance}
                                        </Select.Option>
                                      );
                                    })}
                                </Select>
                              </Tooltip>
                            </Form.Group>
                          </Col>
                        )}

                        {internalCorner.length != 0 && <Col md={4}>
                          <Form.Group
                            className="mb-0"
                            controlId="exampleForm.ControlTextarea1"
                          >
                            {/* working */}
                            <Form.Label className="frm-label">
                              Internal Corner
                            </Form.Label>
                            <Tooltip
                              placement="bottom" // Tooltip appears below the select
                              overlayInnerStyle={{
                                fontSize: "10px",
                                padding: "2px 6px",  // Reduce padding to make it smaller
                                lineHeight: "12px", // Adjust line height to center text
                                minHeight: "20px",  // Ensures tooltip height is minimal
                                display: "flex",
                                alignItems: "center", // Center the text vertically
                              }}
                              title={
                                props.selectedProcess === 1 && !props.isEditingActivatedCnc
                                  ? 'Click "Edit configuration" to modify'
                                  : props.selectedProcess === 2 && !props.isEditingActivatedThreeD
                                    ? 'Click "Edit configuration" to modify'
                                    : ""
                              }
                              mouseEnterDelay={0}
                              mouseLeaveDelay={0} // Instant hide
                            >
                              <Select
                                showSearch
                                optionFilterProp="value"
                                aria-label="Default select example"
                                onChange={(e) => {
                                  handleOptionChange(7, e);
                                }}
                                value={props.singleValue?.cncInternalCorner}
                                className="text-xs -mt-1 w-full"
                                disabled={!props.isEditingActivatedCnc || isGlobalLoading}
                                title=""
                              >
                                <option value="">Select Values</option>
                                {internalCorner?.length > 0 &&
                                  internalCorner.map((Item, index) => {
                                    return (
                                      <Select.Option key={`p-${index}`} value={Item._id}>
                                        {Item.cnc_internal_corner}
                                      </Select.Option>
                                    );
                                  })}
                              </Select>
                            </Tooltip>
                          </Form.Group>
                        </Col>}
                        {reviewDesign.length != 0 ? <Col md={4}>
                          <Form.Group
                            className="mb-0"
                            controlId="exampleForm.ControlTextarea1"
                          >
                            {/* working */}
                            <Form.Label className="frm-label">
                              Review My Design
                            </Form.Label>
                            <Tooltip
                              placement="bottom" // Tooltip appears below the select
                              overlayInnerStyle={{
                                fontSize: "10px",
                                padding: "2px 6px",  // Reduce padding to make it smaller
                                lineHeight: "12px", // Adjust line height to center text
                                minHeight: "20px",  // Ensures tooltip height is minimal
                                display: "flex",
                                alignItems: "center", // Center the text vertically
                              }}
                              title={
                                props.selectedProcess === 1 && !props.isEditingActivatedCnc
                                  ? 'Click "Edit configuration" to modify'
                                  : props.selectedProcess === 2 && !props.isEditingActivatedThreeD
                                    ? 'Click "Edit configuration" to modify'
                                    : ""
                              }
                              mouseEnterDelay={0}
                              mouseLeaveDelay={0} // Instant hide
                            >
                              <Select
                                showSearch
                                optionFilterProp="value"
                                aria-label="Default select example"
                                onChange={(e) => {
                                  handleOptionChange(6, e);
                                }}
                                value={props.singleValue?.cncReviewMyDesign}
                                className="text-xs -mt-1 w-full"
                                disabled={!props.isEditingActivatedCnc || isGlobalLoading}
                                title=""
                              >
                                <option value="">Select Values</option>
                                {reviewDesign?.length > 0 &&
                                  reviewDesign.map((Item, index) => {
                                    return (
                                      <Select.Option key={`p-${index}`} value={Item._id}>
                                        {Item.cnc_review_my_design ? "Yes" : "No"}
                                      </Select.Option>
                                    );
                                  })}
                              </Select>
                            </Tooltip>
                          </Form.Group>
                        </Col> : null}

                        {partMarking.length != 0 && <Col md={4}>
                          <Form.Group
                            className="mb-0"
                            controlId="exampleForm.ControlTextarea1"
                          >
                            {/* working */}
                            <Form.Label className="frm-label">
                              Part Marking
                            </Form.Label>
                            <Tooltip
                              placement="bottom" // Tooltip appears below the select
                              overlayInnerStyle={{
                                fontSize: "10px",
                                padding: "2px 6px",  // Reduce padding to make it smaller
                                lineHeight: "12px", // Adjust line height to center text
                                minHeight: "20px",  // Ensures tooltip height is minimal
                                display: "flex",
                                alignItems: "center", // Center the text vertically
                              }}
                              title={
                                props.selectedProcess === 1 && !props.isEditingActivatedCnc
                                  ? 'Click "Edit configuration" to modify'
                                  : props.selectedProcess === 2 && !props.isEditingActivatedThreeD
                                    ? 'Click "Edit configuration" to modify'
                                    : ""
                              }
                              mouseEnterDelay={0}
                              mouseLeaveDelay={0} // Instant hide
                            >
                              <Select
                                showSearch
                                optionFilterProp="value"
                                aria-label="Default select example"
                                onChange={(e) => {
                                  handleOptionChange(15, e);
                                }}
                                value={props.singleValue?.cncPartMarking}
                                className="text-xs -mt-1 w-full"
                                disabled={!props.isEditingActivatedCnc || isGlobalLoading}
                                title=""
                              >
                                <option value="">Select Values</option>
                                {partMarking?.length > 0 &&
                                  partMarking.map((Item, index) => {
                                    return (
                                      <Select.Option key={`p-${index}`} value={Item._id}>
                                        {Item.cnc_part_marking ? "Yes" : "No"}
                                      </Select.Option>
                                    );
                                  })}
                              </Select>
                            </Tooltip>
                          </Form.Group>
                        </Col>}
                        <Col>
                          <div className="form-left">
                            <Form.Group
                              controlId="exampleForm.ControlTextarea1"
                            >

                              <Form.Label className="frm-label">Description</Form.Label>
                              <Tooltip
                                placement="bottom" // Tooltip appears below the select
                                overlayInnerStyle={{
                                  fontSize: "10px",
                                  padding: "2px 6px",  // Reduce padding to make it smaller
                                  lineHeight: "12px", // Adjust line height to center text
                                  minHeight: "20px",  // Ensures tooltip height is minimal
                                  display: "flex",
                                  alignItems: "center", // Center the text vertically
                                }}
                                title={
                                  props.selectedProcess === 1 && !props.isEditingActivatedCnc
                                    ? 'Click "Edit configuration" to modify'
                                    : props.selectedProcess === 2 && !props.isEditingActivatedThreeD
                                      ? 'Click "Edit configuration" to modify'
                                      : ""
                                }
                                mouseEnterDelay={0}
                                mouseLeaveDelay={0} // Instant hide
                              >
                                <AutoResizingTextarea
                                  maxLength={150}
                                  value={props.singleValue.description}
                                  readOnly={!props.isEditingActivatedCnc || isGlobalLoading}
                                  onChange={(e) => {
                                    try {
                                      props.updateValueOnChange(
                                        props.index,
                                        "description",
                                        e.target.value
                                      );
                                    } catch (err) {
                                      return err;
                                    }
                                  }}

                                />

                              </Tooltip>
                            </Form.Group>
                          </div>
                        </Col>

                      </Row>
                    ) :
                      <>
                        <Row className="w-full"  >
                          <Col md={4}>
                            <Form.Group
                              className="mb-0"
                              controlId="exampleForm.ControlTextarea1"
                            >
                              <Form.Label className="frm-label">
                                Technology/Process
                              </Form.Label>
                              <Tooltip
                                placement="bottom" // Tooltip appears below the select
                                overlayInnerStyle={{
                                  fontSize: "10px",
                                  padding: "2px 6px",  // Reduce padding to make it smaller
                                  lineHeight: "12px", // Adjust line height to center text
                                  minHeight: "20px",  // Ensures tooltip height is minimal
                                  display: "flex",
                                  alignItems: "center", // Center the text vertically
                                }}
                                title={
                                  props.selectedProcess === 1 && !props.isEditingActivatedCnc
                                    ? 'Click "Edit configuration" to modify'
                                    : props.selectedProcess === 2 && !props.isEditingActivatedThreeD
                                      ? 'Click "Edit configuration" to modify'
                                      : ""
                                }
                                mouseEnterDelay={0}
                                mouseLeaveDelay={0} // Instant hide
                              >
                                <Select
                                  showSearch
                                  optionFilterProp="value"
                                  aria-label="Default select example"
                                  onChange={(e) => {
                                    handleOptionChange(11, e);
                                    setIsPostProcessThreeDChangedByDropDown(true);
                                  }}
                                  value={props?.singleValue?.threeDTechnology}
                                  className={` text-xxs -mt-1 w-full`}
                                  disabled={!props.isEditingActivatedThreeD || isGlobalLoading}
                                  title=""
                                >
                                  <option value="">Select Values</option>
                                  {threeDTechnologyData?.length > 0 &&
                                    threeDTechnologyData.map((Item, index) => {
                                      return (
                                        <Select.Option key={`p-${index}`} value={Item._id}>
                                          {Item.name}
                                        </Select.Option>
                                      );
                                    })}
                                </Select>
                              </Tooltip>
                            </Form.Group>
                          </Col>



                          <Col md={4}>
                            <Form.Group
                              className="mb-0"
                              controlId="exampleForm.ControlTextarea1"
                            >
                              {/* working */}
                              <Form.Label className="frm-label">
                                Material
                              </Form.Label>
                              <Tooltip
                                placement="bottom" // Tooltip appears below the select
                                overlayInnerStyle={{
                                  fontSize: "10px",
                                  padding: "2px 6px",  // Reduce padding to make it smaller
                                  lineHeight: "12px", // Adjust line height to center text
                                  minHeight: "20px",  // Ensures tooltip height is minimal
                                  display: "flex",
                                  alignItems: "center", // Center the text vertically
                                }}
                                title={
                                  props.selectedProcess === 1 && !props.isEditingActivatedCnc
                                    ? 'Click "Edit configuration" to modify'
                                    : props.selectedProcess === 2 && !props.isEditingActivatedThreeD
                                      ? 'Click "Edit configuration" to modify'
                                      : ""
                                }
                                mouseEnterDelay={0}
                                mouseLeaveDelay={0} // Instant hide
                              >
                                <Select
                                  showSearch
                                  optionFilterProp="value"
                                  aria-label="Default select example"
                                  onChange={(e) => {
                                    handleOptionChange(13, e);
                                    setIsPostProcessThreeDChangedByDropDown(true);
                                  }}
                                  value={props.singleValue?.threeDMaterial}
                                  className={`text-xs -mt-1 w-full`}
                                  disabled={!props.isEditingActivatedThreeD || isGlobalLoading}
                                  title=""
                                >
                                  <option value="">Select Values</option>
                                  {materialData?.length > 0 &&
                                    materialData.map((Item, index) => {
                                      return (
                                        <Select.Option key={`p-${index}`} value={Item._id}>
                                          {Item.name}
                                        </Select.Option>
                                      );
                                    })}
                                </Select>
                              </Tooltip>
                            </Form.Group>
                          </Col>

                          <Col md={4}>
                            <Form.Group
                              className="mb-0"
                              controlId="exampleForm.ControlTextarea1"
                            >
                              <Form.Label className="frm-label">
                                Surface Finish
                              </Form.Label>

                              <Tooltip
                                placement="bottom" // Tooltip appears below the select
                                overlayInnerStyle={{
                                  fontSize: "10px",
                                  padding: "2px 6px",  // Reduce padding to make it smaller
                                  lineHeight: "12px", // Adjust line height to center text
                                  minHeight: "20px",  // Ensures tooltip height is minimal
                                  display: "flex",
                                  alignItems: "center", // Center the text vertically
                                }}
                                title={
                                  props.selectedProcess === 1 && !props.isEditingActivatedCnc
                                    ? 'Click "Edit configuration" to modify'
                                    : props.selectedProcess === 2 && !props.isEditingActivatedThreeD
                                      ? 'Click "Edit configuration" to modify'
                                      : ""
                                }
                                mouseEnterDelay={0}
                                mouseLeaveDelay={0} // Instant hide
                              >
                                <Select
                                  showSearch
                                  optionFilterProp="value"
                                  aria-label="Default select example"
                                  onChange={(e) => {
                                    handleOptionChange(14, e);
                                  }}
                                  value={props.singleValue?.threeDPostProcessing}
                                  className={`text-xs -mt-1 w-full`}
                                  disabled={!props.isEditingActivatedThreeD || isGlobalLoading}
                                  title=""
                                >
                                  <option value="">Select Values</option>
                                  {surfaceFinishData?.length > 0 &&
                                    surfaceFinishData?.map((Item, index) => {
                                      return (
                                        <Select.Option key={`p-${index}`} value={Item._id}>
                                          <span
                                            title={`${Item.name}${Item.color !== 'NA' ? ` : ${Item.color}` : ''}`}
                                          >
                                            {Item.name + " : "}
                                            <span>{Item.color !== 'NA' && Item.color}</span>
                                          </span>

                                        </Select.Option>
                                      );
                                    })}
                                </Select>
                              </Tooltip>
                            </Form.Group>
                          </Col>
                        </Row>
                      </>}

                  </Form>
                </div>
              </Col>
            </Row>


          </div >

        </div>

      </div>
      <div style={{
        display: isAnyProcessEditingActivated ? "none" : "block"
      }} className=" flex flex-col items-end  " >
        <div className=" ">
          {
            !isGlobalLoading ? <div className="  ">
              {!(
                (!props?.singleValue?.price1 &&
                  !props?.singleValue?.price2 &&
                  !props?.singleValue?.price3
                ) ||
                (props?.singleValue[keyFirst] &&
                  !props?.singleValue[keyFirst][keySecond])
              ) ? <div className="flex flex-col items-end text-sm font-medium">
                {props?.commanValues?.selectedShipMethod === 1 &&
                  !props?.commanValues?.isQuoteChanged &&
                  props?.singleValue?.price1 &&
                  props?.singleValue[keyFirst] &&
                  props?.singleValue[keyFirst][keySecond] ? (
                  <>
                    <div className="text-right">{currencyFormatter(props?.singleValue?.price1 * props?.singleValue?.Qty)}</div>
                    <div className="text-right">
                      {currencyFormatter(props?.singleValue?.price1)}
                      <div className="text-slate-500 text-xs">Each</div>
                    </div>
                  </>
                ) : props?.commanValues?.selectedShipMethod === 2 &&
                  !props?.commanValues?.isQuoteChanged &&
                  props?.singleValue?.price2 &&
                  props?.singleValue[keyFirst] &&
                  props?.singleValue[keyFirst][keySecond] ? (
                  <>
                    <div className="text-right">{currencyFormatter(props?.singleValue?.price2 * props?.singleValue?.Qty)}</div>
                    <div className="text-right">
                      {currencyFormatter(props?.singleValue?.price2)}
                      <div className="text-slate-500 text-xs">Each</div>
                    </div>
                  </>
                ) : props?.commanValues?.selectedShipMethod === 3 &&
                  !props?.commanValues?.isQuoteChanged &&
                  props?.singleValue?.price3 &&
                  props?.singleValue[keyFirst] &&
                  props?.singleValue[keyFirst][keySecond] ? (
                  <>
                    <div className="text-right">{currencyFormatter(props?.singleValue?.price3 * props?.singleValue?.Qty)}</div>
                    <div className="text-right">
                      {currencyFormatter(props?.singleValue?.price3)}
                      <div className="text-slate-500 text-xs">Each</div>
                    </div>
                  </>
                ) : isGlobalLoading ? null : null}
              </div>
                : <p className={` text-[12px] whitespace-nowrap  `}>
                  <span className="text-red-500  flex justify-end">Review Required</span>
                  {!props?.commanValues?.isQuoteChanged &&
                    ((props?.commanValues?.selectedShipMethod === 1 && props?.singleValue?.price1) ||
                      (props?.commanValues?.selectedShipMethod === 2 && props?.singleValue?.price2) ||
                      (props?.commanValues?.selectedShipMethod === 3 && props?.singleValue?.price3)) ? (
                    <div className="text-sm flex flex-col justify-end">
                      {
                        props?.commanValues?.selectedShipMethod === 1 && props?.singleValue?.price1 ? (
                          <div className="flex flex-col font-medium items-end ">
                            <div>{currencyFormatter(props?.singleValue?.price1 * props?.singleValue?.Qty)}</div>
                            <div>{currencyFormatter(props?.singleValue?.price1)} <span className="text-slate-500">Each</span></div>
                          </div>
                        ) : props?.commanValues?.selectedShipMethod === 2 && props?.singleValue?.price2 ? (
                          <div className="flex flex-col font-medium items-end ">
                            <div>{currencyFormatter(props?.singleValue?.price2 * props?.singleValue?.Qty)}</div>
                            <div>{currencyFormatter(props?.singleValue?.price2)} <span className="text-slate-500">Each</span></div>
                          </div>
                        ) : props?.commanValues?.selectedShipMethod === 3 && props?.singleValue?.price3 ? (
                          <div className="flex flex-col font-medium items-end ">
                            <div>{currencyFormatter(props?.singleValue?.price3 * props?.singleValue?.Qty)}</div>
                            <div>{currencyFormatter(props?.singleValue?.price3)} <span className="text-slate-500">Each</span></div>
                          </div>
                        ) : null
                      }
                      <p className="text-red-500 !text-[12px] ">(Estimated part cost)</p>

                    </div>
                  ) : null}

                </p>}
            </div> :
              <div >
                <SmallGlobalLoader
                  height={70}
                />
              </div>
          }
        </div>
        {!isGlobalLoading ? <div className="flex justify-end items-center">
          <label style={{ fontSize: 13, marginRight: 4 }}>Quantity :</label>
          <Tooltip
            placement="bottom"
            overlayInnerStyle={{
              fontSize: "10px",
              padding: "2px 6px",
              lineHeight: "12px",
              minHeight: "20px",
              display: "flex",
              alignItems: "center",
            }}
            title={
              props.selectedProcess === 1 && !props.isEditingActivatedCnc
                ? 'Click on Edit Configuration to modify specification'
                : props.selectedProcess === 2 && !props.isEditingActivatedThreeD
                  ? 'Click on Edit Configuration to modify specification'
                  : ""
            }
            mouseEnterDelay={0}
            mouseLeaveDelay={0}
          >
            <span>
              <p className="text-[14px]">{props.singleValue.Qty}</p>
            </span>
          </Tooltip>
        </div> : null}

        {!isGlobalLoading ? <div className=" flex justify-end">
          <button
            onClick={() => setIsOpenDeleteFileModal(true)}
            className="px-2 py-1 mt-2 bg-red-500 text-white text-xs rounded-md flex items-center gap-1 hover:bg-red-600 transition duration-200"
          >
            <DeleteIcon additionalClasses="text-white h-3 w-3" />
            <span>Delete</span>
          </button>
        </div>
          : <div></div>}
      </div>
    </div >
  );
};
export default AutomatedProcessLinesUI;
